(function(){
"use strict";
const ROOT = document.querySelector('.eli-skt');
if(!ROOT) return;
const $ = s => ROOT.querySelector(s);
const $$ = s => ROOT.querySelectorAll(s);

/* ================================================================
   Config iniettata dal tema (sezione Liquid) — assente nella demo
   standalone, quindi ogni valore ricade sul default. In produzione
   la section imposta window.ELI_SKT_CFG dalle impostazioni dell'editor.
   ================================================================ */
const CFG = (typeof window !== "undefined" && window.ELI_SKT_CFG) || {};

/* Solo demo standalone (nessuna config iniettata): la modalità negozio si
   può provare da URL — ?kiosk=1&perstep=2&pricetier=1 — senza toccare il
   codice. In produzione comanda solo l'editor tema. */
if(typeof window !== "undefined" && !window.ELI_SKT_CFG){
  try{
    const q = new URLSearchParams(location.search);
    if(q.get("kiosk") === "1")    CFG.kiosk = true;
    if(q.get("pricetier") === "1") CFG.priceTier = true;
    const ps = parseInt(q.get("perstep") || "", 10);
    if(ps >= 1 && ps <= 3) CFG.perStep = ps;
    // prova della spinta manuale: ?push=<handle>&pushw=40
    const pw = parseInt(q.get("pushw") || "", 10);
    if(pw >= 0 && pw <= 100) CFG.pushWeight = pw / 100;
    if(q.get("push")) CFG._demoPush = q.get("push");
  } catch {}
}

/* ================================================================
   i18n
   ================================================================ */
const I18N = {
it:{
  demoNote:"La foto resta sul tuo dispositivo",
  introEyebrow:"Analisi della pelle",
  introTitle:"Scopri di cosa ha bisogno la tua pelle",
  introLead:"Tre domande, uno scatto. In meno di un minuto ricevi una routine coreana costruita sulle tue esigenze reali, con prodotti disponibili subito.",
  usp1t:"3 domande", usp1p:"Età, tipo di pelle e cosa ti dà più fastidio.",
  usp2t:"Uno scatto", usp2p:"Con la fotocamera o caricando una foto già scattata.",
  usp3t:"La tua routine", usp3p:"5 passaggi, ordinabili con un clic.",
  consentLabel:"Acconsento all'uso della fotocamera per questa analisi. La foto viene elaborata solo per generare il consiglio e non viene salvata né condivisa.",
  consentErr:"Spunta la casella qui sopra per continuare.",
  introCta:"Inizia il test", introSkip:"Preferisco solo il questionario",
  navBack:"Indietro", navNext:"Continua",
  camTitle:"Inquadra il viso",
  camHint:"Luce naturale, niente occhiali, capelli lontani dal viso.",
  camNote:"Il conteggio parte al tocco: hai 3 secondi per sistemarti.",
  camUpload:"Carica una foto invece",
  errTitle:"Fotocamera non disponibile", errUpload:"Carica una foto",
  errSkip:"Continua solo col questionario",
  checkTitle:"Va bene questa foto?",
  checkHint:"Il viso deve essere a fuoco, illuminato in modo uniforme e senza ombre forti.",
  checkRetake:"Riscatta", checkUse:"Usa questa foto",
  warnDark:"La foto è molto scura: l'analisi sarà meno affidabile. Meglio riscattare vicino a una finestra.",
  warnBright:"Luce troppo forte e diretta: i riflessi vengono letti come pelle lucida.",
  warnFlat:"Si vede poco dettaglio della pelle. Avvicinati un po' e tieni fermo.",
  goPhoto:"Vai alla foto",
  runTitle:"Analisi in corso…",
  scoresTitle:"Il profilo della tua pelle",
  resTitle:"Ecco la routine costruita per te",
  sumAllGood:"Tutti gli indici sono in fascia sana: non c'è nulla da correggere. Questa routine serve a mantenere il risultato, con l'accento su protezione solare e barriera.",
  sumFocus:"Nelle prossime 8 settimane concentrati su {a} e {b}: sono i due punti che incidono di più sul risultato.",
  noteUnreadable:"La foto non era leggibile (troppo scura, troppo chiara o senza dettaglio della pelle) e non è stata usata per il punteggio: quanto segue deriva solo dal questionario. Con uno scatto in luce uniforme il risultato è molto più preciso.",
  focusTag:"focus",
  routineTitle:"La tua routine K-beauty",
  routineSub:"Segui l'ordine mattina e sera. La protezione solare solo di mattina, il booster 2 volte a settimana.",
  ringLabel:"Indice complessivo",
  exclusive:"Solo da ELI",
  totalLabel:"Totale selezione", addSel:"Aggiungi al carrello",
  saveBadge:"Risparmi {x}",
  pickCore:"Solo essenziale", pickAll:"Routine completa",
  pickTen:"Rituale coreano",
  altBadge:"Alternativa",
  kioskCnt:"{n} prodotti selezionati",
  kioskMsg:"Mostra questa schermata a un membro del nostro staff: prepara per te i prodotti selezionati. Lascia l'email qui sotto per ricevere la routine completa sul tuo telefono.",
  cntSel:"{n} prodotti selezionati",
  hintNeed:"Seleziona almeno 3 prodotti per attivare lo sconto",
  hintOk:"Sconto {p}% attivo su questa routine",
  view:"Vedi ↗",
  assurShip:"<b>Spedizione dall'Italia</b> — consegna in 2-3 giorni lavorativi",
  assurFree:"<b>Spedizione gratuita</b> sopra {x}",
  assurRet:"<b>Reso entro 30 giorni</b>",
  assurHelp:"<b>Assistenza in italiano</b>",
  gateTitle:"Hai già fatto il test",
  gateLead:"Crea un account per confrontare questo nuovo test con il precedente e vedere come è cambiata la tua pelle.",
  gateCta:"Crea account", gateSkip:"Rifai il test senza salvare",
  gateNote:"Serve solo per salvare i tuoi risultati. Nessuna foto viene conservata.",
  gatePrev:"Il tuo test precedente",
  deltaUp:"+{x} punti rispetto al {d}", deltaDown:"−{x} punti rispetto al {d}",
  deltaFlat:"Invariato rispetto al {d}",
  pcapTitle:"La tua analisi è pronta",
  pcapLead:"Dicci dove mandarla: ricevi la routine completa via email, con i prodotti e lo sconto già applicato — così la ritrovi quando vuoi.",
  pcapLeadKiosk:"Dicci dove mandarla: ricevi via email il tuo profilo pelle e la routine completa — così la ritrovi quando vuoi.",
  pcapCta:"Vedi i risultati",
  pcapSkip:"Vai ai risultati senza lasciare l'email",
  pcapName:"Nome (facoltativo)",
  capTitle:"Ricevi la tua routine via email",
  capLead:"Ti mandiamo il piano completo con i passaggi mattina/sera e un promemoria per rifare il test tra 8 settimane.",
  capCta:"Invia",
  capNote:"Iscrivendoti accetti di ricevere email da ELI Cosmetics. Puoi disiscriverti quando vuoi.",
  capDone:"Fatto ✓ Ti scriviamo a breve.",
  capFail:"Non ha funzionato. Riprova fra poco.",
  again:"Rifai il test",
  catBtn:"Sfoglia il catalogo prodotti →",
  catBtnTop:"Vai al catalogo",
  disclaimer:"Questa analisi è uno strumento di consulenza cosmetica e non costituisce una diagnosi medica. Per condizioni della pelle persistenti rivolgiti a un dermatologo.",
  devTitle:"Pannello tecnico (solo demo)",
  devIntro:"Valori misurati sul fotogramma, dentro l'ellisse del viso. In questa demo il punteggio è calcolato in locale con euristiche su canvas; in produzione questi stessi pixel verrebbero inviati a un endpoint che chiama un modello vision e restituisce lo stesso schema JSON.",
  devFoot:"Nessuna immagine lascia il browser in questa demo."
},
en:{
  demoNote:"Your photo stays on your device",
  introEyebrow:"Skin analysis",
  introTitle:"Discover what your skin really needs",
  introLead:"Three questions, one photo. In under a minute you get a Korean skincare routine built on your real needs, with products available right now.",
  usp1t:"3 questions", usp1p:"Age, skin type and what bothers you most.",
  usp2t:"One photo", usp2p:"With your camera, or by uploading one you already have.",
  usp3t:"Your routine", usp3p:"5 steps, add them to cart in one click.",
  consentLabel:"I agree to use the camera for this analysis. The photo is processed only to generate the recommendation and is never saved or shared.",
  consentErr:"Tick the box above to continue.",
  introCta:"Start the test", introSkip:"I'd rather just do the quiz",
  navBack:"Back", navNext:"Continue",
  camTitle:"Frame your face",
  camHint:"Natural light, no glasses, hair away from your face.",
  camNote:"A 3-second countdown starts when you tap, so you have time to get ready.",
  camUpload:"Upload a photo instead",
  errTitle:"Camera not available", errUpload:"Upload a photo",
  errSkip:"Continue with the quiz only",
  checkTitle:"Is this photo OK?",
  checkHint:"Your face should be in focus, evenly lit and without harsh shadows.",
  checkRetake:"Retake", checkUse:"Use this photo",
  warnDark:"The photo is very dark: the analysis will be less reliable. Better to retake it near a window.",
  warnBright:"Light too strong and direct: the reflections get read as oily skin.",
  warnFlat:"Very little skin detail is visible. Move a little closer and hold steady.",
  goPhoto:"Go to the photo",
  runTitle:"Analysing…",
  scoresTitle:"Your skin profile",
  resTitle:"Here's the routine built for you",
  sumAllGood:"Every index is in the healthy range: there's nothing to correct. This routine is about maintaining the result, with an emphasis on sunscreen and barrier care.",
  sumFocus:"Over the next 8 weeks focus on {a} and {b}: they're the two things that most affect your result.",
  noteUnreadable:"The photo wasn't readable (too dark, too bright or without skin detail) and wasn't used for the score: what follows comes from the quiz only. With an evenly-lit shot the result is much more precise.",
  focusTag:"focus",
  routineTitle:"Your K-beauty routine",
  routineSub:"Follow the order morning and evening. Sunscreen in the morning only, the booster twice a week.",
  ringLabel:"Overall index",
  exclusive:"Only at ELI",
  totalLabel:"Selection total", addSel:"Add to cart",
  saveBadge:"Save {x}",
  pickCore:"Essentials only", pickAll:"Full routine",
  pickTen:"10-step ritual",
  altBadge:"Alternative",
  kioskCnt:"{n} products selected",
  kioskMsg:"Show this screen to a member of our staff: they'll gather your selected products for you. Leave your email below to get the full routine on your phone.",
  cntSel:"{n} products selected",
  hintNeed:"Select at least 3 products to unlock the discount",
  hintOk:"{p}% discount active on this routine",
  view:"View ↗",
  assurShip:"<b>Ships from Italy</b> — delivered in 2-3 working days",
  assurFree:"<b>Free shipping</b> over {x}",
  assurRet:"<b>30-day returns</b>",
  assurHelp:"<b>Support in Italian & English</b>",
  gateTitle:"You've already taken the test",
  gateLead:"Create an account to compare this new test with the previous one and see how your skin has changed.",
  gateCta:"Create account", gateSkip:"Retake without saving",
  gateNote:"Only used to save your results. No photo is kept.",
  gatePrev:"Your previous test",
  deltaUp:"+{x} points vs {d}", deltaDown:"−{x} points vs {d}",
  deltaFlat:"Unchanged vs {d}",
  pcapTitle:"Your analysis is ready",
  pcapLead:"Tell us where to send it: you'll get the full routine by email, products and discount included — so you can come back to it any time.",
  pcapLeadKiosk:"Tell us where to send it: you'll get your skin profile and full routine by email — so you can come back to it any time.",
  pcapCta:"See my results",
  pcapSkip:"Go to results without leaving my email",
  pcapName:"Name (optional)",
  capTitle:"Get your routine by email",
  capLead:"We'll send you the full plan with morning/evening steps and a reminder to retake the test in 8 weeks.",
  capCta:"Send",
  capNote:"By subscribing you agree to receive emails from ELI Cosmetics. You can unsubscribe any time.",
  capDone:"Done ✓ We'll be in touch shortly.",
  capFail:"That didn't work. Please try again in a moment.",
  again:"Retake the test",
  catBtn:"Browse the product catalog →",
  catBtnTop:"Go to catalog",
  disclaimer:"This analysis is a cosmetic-consultation tool and is not a medical diagnosis. For persistent skin conditions, consult a dermatologist.",
  devTitle:"Technical panel (demo only)",
  devIntro:"Values measured on the frame, inside the face ellipse. In this demo the score is computed locally with canvas heuristics; in production these same pixels would be sent to an endpoint that calls a vision model and returns the same JSON schema.",
  devFoot:"No image leaves the browser in this demo."
},
zh:{
  demoNote:"照片仅停留在你的设备上",
  introEyebrow:"肌肤分析",
  introTitle:"看看你的皮肤真正需要什么",
  introLead:"三个问题，一张自拍。不到一分钟，就能得到一套按你实际状况搭配、且现货可买的韩系护肤流程。",
  usp1t:"3 个问题", usp1p:"年龄、肤质，以及你最在意的问题。",
  usp2t:"一张照片", usp2p:"现场拍摄，或上传已有的照片。",
  usp3t:"你的专属流程", usp3p:"5 个步骤，一键加入购物车。",
  consentLabel:"我同意为本次分析使用摄像头。照片仅用于生成建议，不会被保存或分享。",
  consentErr:"请先勾选上面的同意框。",
  introCta:"开始测试", introSkip:"我只想做问卷",
  navBack:"返回", navNext:"继续",
  camTitle:"把脸放进框里",
  camHint:"自然光、摘掉眼镜、把头发拨到脸外。",
  camNote:"点击后开始 3 秒倒计时，你有时间调整姿势。",
  camUpload:"改为上传照片",
  errTitle:"无法使用摄像头", errUpload:"上传一张照片",
  errSkip:"只用问卷继续",
  checkTitle:"这张可以吗？",
  checkHint:"脸要清晰、光线均匀，避免明显的阴影。",
  checkRetake:"重拍", checkUse:"就用这张",
  warnDark:"照片偏暗，分析可靠性会下降。建议靠窗重拍一张。",
  warnBright:"光太强太直，反光会被误判成皮肤出油。",
  warnFlat:"皮肤细节太少。靠近一点，拿稳手机。",
  goPhoto:"去拍照",
  runTitle:"分析中…",
  scoresTitle:"你的肌肤档案",
  resTitle:"这是我们为你搭配的流程",
  sumAllGood:"各项都在健康区间，没有需要纠正的问题。下面这套的作用是维持现状——重点是防晒和屏障养护。",
  sumFocus:"接下来 8 周，重点放在「{a}」和「{b}」这两项上，其他指标保持现状即可。",
  noteUnreadable:"这次的照片太暗/太亮或看不清皮肤细节，没有用于评分——下面的结果只来自你的问卷。重新拍一张光线均匀的照片会准得多。",
  focusTag:"重点",
  routineTitle:"你的 K-beauty 流程",
  routineSub:"早晚按顺序使用；防晒只在早晨，加强款每周 2 次。",
  ringLabel:"综合指数",
  exclusive:"仅 ELI 有售",
  totalLabel:"已选合计", addSel:"加入购物车",
  saveBadge:"省 {x}",
  pickCore:"只要核心", pickAll:"完整流程",
  pickTen:"十步全套",
  altBadge:"备选",
  kioskCnt:"已选 {n} 件",
  kioskMsg:"把这个页面出示给店员，我们会为你把选中的产品拿好。在下方留下邮箱，完整方案会发到你的手机。",
  cntSel:"已选 {n} 件",
  hintNeed:"选满 3 件解锁折扣",
  hintOk:"已享 {p}% 折扣",
  view:"查看 ↗",
  assurShip:"<b>意大利本地发货</b> — 2-3 个工作日送达",
  assurFree:"满 {x} <b>免运费</b>",
  assurRet:"<b>30 天内可退</b>",
  assurHelp:"<b>意大利语客服</b>",
  gateTitle:"你已经测过一次了",
  gateLead:"创建账号即可把这次结果和上次对比，看看皮肤有什么变化。",
  gateCta:"创建账号", gateSkip:"不保存，直接重测",
  gateNote:"仅用于保存你的结果。照片不会被保留。",
  gatePrev:"你上一次的测试",
  deltaUp:"比 {d} 提升 {x} 分", deltaDown:"比 {d} 下降 {x} 分",
  deltaFlat:"与 {d} 持平",
  pcapTitle:"你的分析已完成",
  pcapLead:"告诉我们发到哪里：完整方案会连同产品和折扣一起发到你的邮箱，随时都能找回来。",
  pcapLeadKiosk:"告诉我们发到哪里：你的皮肤档案和完整方案会发到你的邮箱，随时都能找回来。",
  pcapCta:"查看结果",
  pcapSkip:"不留邮箱，直接看结果",
  pcapName:"名字（选填）",
  capTitle:"把这套流程发到你的邮箱",
  capLead:"我们会寄给你完整的早晚步骤表，并在 8 周后提醒你复测。",
  capCta:"发送",
  capNote:"订阅即表示同意接收 ELI Cosmetics 的邮件，可随时退订。",
  capDone:"已提交 ✓ 我们会尽快联系你。",
  capFail:"提交失败，请稍后再试。",
  again:"重新测试",
  catBtn:"浏览产品目录 →",
  catBtnTop:"查看产品目录",
  disclaimer:"本分析属于美容咨询工具，不构成医疗诊断。皮肤问题持续存在请咨询皮肤科医生。",
  devTitle:"技术面板（仅 demo）",
  devIntro:"下面是从画面中人脸椭圆区域实测出的数值。本 demo 用 canvas 启发式算法在本地算分；生产版把同样这些像素发给一个后端接口，由 vision 模型返回同样结构的 JSON。",
  devFoot:"本 demo 中没有任何图片离开浏览器。"
},
de:{
  demoNote:"Dein Foto bleibt auf deinem Gerät",
  introEyebrow:"Hautanalyse",
  introTitle:"Finde heraus, was deine Haut wirklich braucht",
  introLead:"Drei Fragen, ein Foto. In weniger als einer Minute bekommst du eine koreanische Skincare-Routine nach deinen echten Bedürfnissen — mit sofort verfügbaren Produkten.",
  usp1t:"3 Fragen", usp1p:"Alter, Hauttyp und was dich am meisten stört.",
  usp2t:"Ein Foto", usp2p:"Mit der Kamera oder als Upload eines vorhandenen Fotos.",
  usp3t:"Deine Routine", usp3p:"5 Schritte, mit einem Klick in den Warenkorb.",
  consentLabel:"Ich stimme der Nutzung der Kamera für diese Analyse zu. Das Foto wird nur zur Erstellung der Empfehlung verarbeitet und weder gespeichert noch weitergegeben.",
  consentErr:"Setze oben das Häkchen, um fortzufahren.",
  introCta:"Test starten", introSkip:"Lieber nur den Fragebogen",
  navBack:"Zurück", navNext:"Weiter",
  camTitle:"Gesicht ins Bild",
  camHint:"Tageslicht, keine Brille, Haare aus dem Gesicht.",
  camNote:"Beim Antippen startet ein 3-Sekunden-Countdown — Zeit, dich zurechtzurücken.",
  camUpload:"Stattdessen ein Foto hochladen",
  errTitle:"Kamera nicht verfügbar", errUpload:"Foto hochladen",
  errSkip:"Nur mit dem Fragebogen fortfahren",
  checkTitle:"Passt dieses Foto?",
  checkHint:"Das Gesicht sollte scharf, gleichmäßig beleuchtet und ohne harte Schatten sein.",
  checkRetake:"Neu aufnehmen", checkUse:"Dieses Foto verwenden",
  warnDark:"Das Foto ist sehr dunkel: Die Analyse wird weniger zuverlässig. Besser in Fensternähe neu aufnehmen.",
  warnBright:"Zu starkes, direktes Licht: Reflexe werden als ölige Haut gelesen.",
  warnFlat:"Es ist wenig Hautdetail zu sehen. Geh etwas näher ran und halte still.",
  goPhoto:"Zum Foto",
  runTitle:"Analyse läuft…",
  scoresTitle:"Dein Hautprofil",
  resTitle:"Deine persönliche Routine ist da",
  sumAllGood:"Alle Werte liegen im gesunden Bereich: Es gibt nichts zu korrigieren. Diese Routine erhält das Ergebnis — mit Fokus auf Sonnenschutz und Hautbarriere.",
  sumFocus:"Konzentriere dich in den nächsten 8 Wochen auf {a} und {b}: Diese beiden Punkte bringen am meisten.",
  noteUnreadable:"Das Foto war nicht lesbar (zu dunkel, zu hell oder ohne Hautdetail) und wurde nicht für die Bewertung verwendet: Das Folgende basiert nur auf dem Fragebogen. Mit einem gleichmäßig beleuchteten Foto wird das Ergebnis deutlich genauer.",
  focusTag:"Fokus",
  routineTitle:"Deine K-Beauty-Routine",
  routineSub:"Folge der Reihenfolge morgens und abends. Sonnenschutz nur morgens, der Booster 2× pro Woche.",
  ringLabel:"Gesamtindex",
  exclusive:"Nur bei ELI",
  totalLabel:"Summe der Auswahl", addSel:"In den Warenkorb",
  saveBadge:"Du sparst {x}",
  pickCore:"Nur das Wesentliche", pickAll:"Komplette Routine",
  pickTen:"Koreanisches Ritual",
  altBadge:"Alternative",
  kioskCnt:"{n} Produkte ausgewählt",
  kioskMsg:"Zeig diesen Bildschirm unserem Personal: Wir stellen die ausgewählten Produkte für dich zusammen. Hinterlasse unten deine E-Mail, um die komplette Routine auf dein Handy zu bekommen.",
  cntSel:"{n} Produkte ausgewählt",
  hintNeed:"Wähle mindestens 3 Produkte, um den Rabatt zu aktivieren",
  hintOk:"{p}% Rabatt auf diese Routine aktiv",
  view:"Ansehen ↗",
  assurShip:"<b>Versand aus Italien</b> — Lieferung in 2-3 Werktagen",
  assurFree:"<b>Gratisversand</b> ab {x}",
  assurRet:"<b>30 Tage Rückgaberecht</b>",
  assurHelp:"<b>Support auf Italienisch & Englisch</b>",
  gateTitle:"Du hast den Test schon gemacht",
  gateLead:"Erstelle ein Konto, um diesen Test mit dem letzten zu vergleichen und zu sehen, wie sich deine Haut verändert hat.",
  gateCta:"Konto erstellen", gateSkip:"Ohne Speichern wiederholen",
  gateNote:"Dient nur zum Speichern deiner Ergebnisse. Es wird kein Foto aufbewahrt.",
  gatePrev:"Dein letzter Test",
  deltaUp:"+{x} Punkte seit dem {d}", deltaDown:"−{x} Punkte seit dem {d}",
  deltaFlat:"Unverändert seit dem {d}",
  pcapTitle:"Deine Analyse ist fertig",
  pcapLead:"Sag uns, wohin wir sie schicken sollen: Du bekommst die komplette Routine per E-Mail, mit Produkten und bereits angewendetem Rabatt — so findest du sie jederzeit wieder.",
  pcapLeadKiosk:"Sag uns, wohin wir sie schicken sollen: Du bekommst dein Hautprofil und die komplette Routine per E-Mail — so findest du sie jederzeit wieder.",
  pcapCta:"Ergebnisse ansehen",
  pcapSkip:"Zu den Ergebnissen ohne E-Mail",
  pcapName:"Vorname (optional)",
  capTitle:"Erhalte deine Routine per E-Mail",
  capLead:"Wir schicken dir den kompletten Plan mit den Schritten für morgens/abends und einer Erinnerung, den Test in 8 Wochen zu wiederholen.",
  capCta:"Senden",
  capNote:"Mit der Anmeldung stimmst du E-Mails von ELI Cosmetics zu. Du kannst dich jederzeit abmelden.",
  capDone:"Fertig ✓ Du hörst gleich von uns.",
  capFail:"Hat nicht geklappt. Versuch es gleich noch einmal.",
  again:"Test wiederholen",
  catBtn:"Produktkatalog ansehen →",
  catBtnTop:"Zum Katalog",
  disclaimer:"Diese Analyse ist ein kosmetisches Beratungstool und keine medizinische Diagnose. Bei anhaltenden Hautproblemen wende dich an eine dermatologische Praxis.",
  devTitle:"Technik-Panel (nur Demo)",
  devIntro:"Auf dem Frame innerhalb der Gesichtsellipse gemessene Werte. In dieser Demo wird lokal mit Canvas-Heuristiken bewertet; in Produktion gehen dieselben Pixel an einen Endpoint mit Vision-Modell, das dasselbe JSON-Schema zurückgibt.",
  devFoot:"In dieser Demo verlässt kein Bild den Browser."
},
fr:{
  demoNote:"Ta photo reste sur ton appareil",
  introEyebrow:"Analyse de peau",
  introTitle:"Découvre ce dont ta peau a vraiment besoin",
  introLead:"Trois questions, une photo. En moins d'une minute, tu reçois une routine coréenne construite sur tes vrais besoins, avec des produits disponibles immédiatement.",
  usp1t:"3 questions", usp1p:"Âge, type de peau et ce qui te gêne le plus.",
  usp2t:"Une photo", usp2p:"Avec l'appareil photo ou en important une photo existante.",
  usp3t:"Ta routine", usp3p:"5 étapes, à ajouter au panier en un clic.",
  consentLabel:"J'accepte l'utilisation de la caméra pour cette analyse. La photo n'est traitée que pour générer la recommandation ; elle n'est ni enregistrée ni partagée.",
  consentErr:"Coche la case ci-dessus pour continuer.",
  introCta:"Commencer le test", introSkip:"Je préfère juste le questionnaire",
  navBack:"Retour", navNext:"Continuer",
  camTitle:"Cadre ton visage",
  camHint:"Lumière naturelle, pas de lunettes, cheveux dégagés du visage.",
  camNote:"Le compte à rebours de 3 secondes démarre au toucher : tu as le temps de te placer.",
  camUpload:"Importer une photo à la place",
  errTitle:"Caméra non disponible", errUpload:"Importer une photo",
  errSkip:"Continuer avec le questionnaire seul",
  checkTitle:"Cette photo convient ?",
  checkHint:"Le visage doit être net, éclairé uniformément et sans ombres marquées.",
  checkRetake:"Reprendre", checkUse:"Utiliser cette photo",
  warnDark:"La photo est très sombre : l'analyse sera moins fiable. Mieux vaut la reprendre près d'une fenêtre.",
  warnBright:"Lumière trop forte et directe : les reflets sont lus comme une peau grasse.",
  warnFlat:"On voit peu de détails de la peau. Rapproche-toi un peu et ne bouge plus.",
  goPhoto:"Aller à la photo",
  runTitle:"Analyse en cours…",
  scoresTitle:"Le profil de ta peau",
  resTitle:"Voici la routine créée pour toi",
  sumAllGood:"Tous les indices sont dans la zone saine : il n'y a rien à corriger. Cette routine sert à maintenir le résultat, avec un accent sur la protection solaire et la barrière cutanée.",
  sumFocus:"Pendant les 8 prochaines semaines, concentre-toi sur {a} et {b} : ce sont les deux points qui comptent le plus.",
  noteUnreadable:"La photo n'était pas lisible (trop sombre, trop claire ou sans détail de peau) et n'a pas été utilisée pour le score : ce qui suit vient uniquement du questionnaire. Avec une photo à la lumière uniforme, le résultat est bien plus précis.",
  focusTag:"priorité",
  routineTitle:"Ta routine K-beauty",
  routineSub:"Suis l'ordre matin et soir. La protection solaire uniquement le matin, le booster 2 fois par semaine.",
  ringLabel:"Indice global",
  exclusive:"Uniquement chez ELI",
  totalLabel:"Total de la sélection", addSel:"Ajouter au panier",
  saveBadge:"Tu économises {x}",
  pickCore:"L'essentiel seulement", pickAll:"Routine complète",
  pickTen:"Rituel coréen",
  altBadge:"Alternative",
  kioskCnt:"{n} produits sélectionnés",
  kioskMsg:"Montre cet écran à un membre de notre équipe : nous préparons pour toi les produits sélectionnés. Laisse ton e-mail ci-dessous pour recevoir la routine complète sur ton téléphone.",
  cntSel:"{n} produits sélectionnés",
  hintNeed:"Sélectionne au moins 3 produits pour activer la remise",
  hintOk:"Remise de {p}% active sur cette routine",
  view:"Voir ↗",
  assurShip:"<b>Expédition depuis l'Italie</b> — livraison en 2-3 jours ouvrés",
  assurFree:"<b>Livraison gratuite</b> dès {x}",
  assurRet:"<b>Retour sous 30 jours</b>",
  assurHelp:"<b>Assistance en italien & anglais</b>",
  gateTitle:"Tu as déjà fait le test",
  gateLead:"Crée un compte pour comparer ce nouveau test avec le précédent et voir comment ta peau a évolué.",
  gateCta:"Créer un compte", gateSkip:"Refaire le test sans enregistrer",
  gateNote:"Sert uniquement à sauvegarder tes résultats. Aucune photo n'est conservée.",
  gatePrev:"Ton test précédent",
  deltaUp:"+{x} points depuis le {d}", deltaDown:"−{x} points depuis le {d}",
  deltaFlat:"Inchangé depuis le {d}",
  pcapTitle:"Ton analyse est prête",
  pcapLead:"Dis-nous où l'envoyer : tu reçois la routine complète par e-mail, avec les produits et la remise déjà appliquée — pour la retrouver quand tu veux.",
  pcapLeadKiosk:"Dis-nous où l'envoyer : tu reçois ton profil de peau et la routine complète par e-mail — pour la retrouver quand tu veux.",
  pcapCta:"Voir les résultats",
  pcapSkip:"Voir les résultats sans laisser d'e-mail",
  pcapName:"Prénom (facultatif)",
  capTitle:"Reçois ta routine par e-mail",
  capLead:"On t'envoie le plan complet avec les étapes matin/soir et un rappel pour refaire le test dans 8 semaines.",
  capCta:"Envoyer",
  capNote:"En t'inscrivant, tu acceptes de recevoir des e-mails d'ELI Cosmetics. Tu peux te désinscrire à tout moment.",
  capDone:"C'est fait ✓ On t'écrit très vite.",
  capFail:"Ça n'a pas fonctionné. Réessaie dans un instant.",
  again:"Refaire le test",
  catBtn:"Parcourir le catalogue produits →",
  catBtnTop:"Voir le catalogue",
  disclaimer:"Cette analyse est un outil de conseil cosmétique et ne constitue pas un diagnostic médical. Pour des problèmes de peau persistants, consulte un dermatologue.",
  devTitle:"Panneau technique (démo uniquement)",
  devIntro:"Valeurs mesurées sur l'image, dans l'ellipse du visage. Dans cette démo, le score est calculé en local avec des heuristiques canvas ; en production, ces mêmes pixels sont envoyés à un endpoint qui appelle un modèle vision et renvoie le même schéma JSON.",
  devFoot:"Aucune image ne quitte le navigateur dans cette démo."
},
es:{
  demoNote:"Tu foto se queda en tu dispositivo",
  introEyebrow:"Análisis de piel",
  introTitle:"Descubre lo que tu piel realmente necesita",
  introLead:"Tres preguntas, una foto. En menos de un minuto recibes una rutina coreana creada según tus necesidades reales, con productos disponibles al momento.",
  usp1t:"3 preguntas", usp1p:"Edad, tipo de piel y lo que más te molesta.",
  usp2t:"Una foto", usp2p:"Con la cámara o subiendo una foto que ya tengas.",
  usp3t:"Tu rutina", usp3p:"5 pasos, añádelos al carrito con un clic.",
  consentLabel:"Acepto el uso de la cámara para este análisis. La foto se procesa solo para generar la recomendación y no se guarda ni se comparte.",
  consentErr:"Marca la casilla de arriba para continuar.",
  introCta:"Empezar el test", introSkip:"Prefiero solo el cuestionario",
  navBack:"Atrás", navNext:"Continuar",
  camTitle:"Encuadra tu cara",
  camHint:"Luz natural, sin gafas, con el pelo apartado de la cara.",
  camNote:"La cuenta atrás de 3 segundos empieza al tocar: tienes tiempo para colocarte.",
  camUpload:"Subir una foto en su lugar",
  errTitle:"Cámara no disponible", errUpload:"Subir una foto",
  errSkip:"Continuar solo con el cuestionario",
  checkTitle:"¿Vale esta foto?",
  checkHint:"La cara debe estar enfocada, iluminada de forma uniforme y sin sombras marcadas.",
  checkRetake:"Repetir", checkUse:"Usar esta foto",
  warnDark:"La foto es muy oscura: el análisis será menos fiable. Mejor repítela cerca de una ventana.",
  warnBright:"Luz demasiado fuerte y directa: los reflejos se interpretan como piel grasa.",
  warnFlat:"Se ve poco detalle de la piel. Acércate un poco y no te muevas.",
  goPhoto:"Ir a la foto",
  runTitle:"Analizando…",
  scoresTitle:"El perfil de tu piel",
  resTitle:"Aquí tienes la rutina creada para ti",
  sumAllGood:"Todos los índices están en la franja saludable: no hay nada que corregir. Esta rutina sirve para mantener el resultado, con énfasis en la protección solar y la barrera cutánea.",
  sumFocus:"Durante las próximas 8 semanas céntrate en {a} y {b}: son los dos puntos que más influyen en el resultado.",
  noteUnreadable:"La foto no era legible (demasiado oscura, demasiado clara o sin detalle de la piel) y no se ha usado para la puntuación: lo que sigue proviene solo del cuestionario. Con una foto de luz uniforme el resultado es mucho más preciso.",
  focusTag:"prioridad",
  routineTitle:"Tu rutina K-beauty",
  routineSub:"Sigue el orden mañana y noche. El protector solar solo por la mañana, el booster 2 veces por semana.",
  ringLabel:"Índice global",
  exclusive:"Solo en ELI",
  totalLabel:"Total de la selección", addSel:"Añadir al carrito",
  saveBadge:"Ahorras {x}",
  pickCore:"Solo lo esencial", pickAll:"Rutina completa",
  pickTen:"Ritual coreano",
  altBadge:"Alternativa",
  kioskCnt:"{n} productos seleccionados",
  kioskMsg:"Enseña esta pantalla a alguien de nuestro equipo: te preparamos los productos seleccionados. Deja tu email aquí abajo para recibir la rutina completa en tu móvil.",
  cntSel:"{n} productos seleccionados",
  hintNeed:"Selecciona al menos 3 productos para activar el descuento",
  hintOk:"Descuento del {p}% activo en esta rutina",
  view:"Ver ↗",
  assurShip:"<b>Envío desde Italia</b> — entrega en 2-3 días laborables",
  assurFree:"<b>Envío gratis</b> a partir de {x}",
  assurRet:"<b>Devolución en 30 días</b>",
  assurHelp:"<b>Atención en italiano e inglés</b>",
  gateTitle:"Ya has hecho el test",
  gateLead:"Crea una cuenta para comparar este nuevo test con el anterior y ver cómo ha cambiado tu piel.",
  gateCta:"Crear cuenta", gateSkip:"Repetir el test sin guardar",
  gateNote:"Solo sirve para guardar tus resultados. No se conserva ninguna foto.",
  gatePrev:"Tu test anterior",
  deltaUp:"+{x} puntos desde el {d}", deltaDown:"−{x} puntos desde el {d}",
  deltaFlat:"Sin cambios desde el {d}",
  pcapTitle:"Tu análisis está listo",
  pcapLead:"Dinos dónde enviarlo: recibes la rutina completa por email, con los productos y el descuento ya aplicado — así la recuperas cuando quieras.",
  pcapLeadKiosk:"Dinos dónde enviarlo: recibes por email tu perfil de piel y la rutina completa — así la recuperas cuando quieras.",
  pcapCta:"Ver los resultados",
  pcapSkip:"Ir a los resultados sin dejar el email",
  pcapName:"Nombre (opcional)",
  capTitle:"Recibe tu rutina por email",
  capLead:"Te enviamos el plan completo con los pasos de mañana/noche y un recordatorio para repetir el test en 8 semanas.",
  capCta:"Enviar",
  capNote:"Al suscribirte aceptas recibir emails de ELI Cosmetics. Puedes darte de baja cuando quieras.",
  capDone:"Hecho ✓ Te escribimos muy pronto.",
  capFail:"No ha funcionado. Inténtalo de nuevo en un momento.",
  again:"Repetir el test",
  catBtn:"Explora el catálogo de productos →",
  catBtnTop:"Ver el catálogo",
  disclaimer:"Este análisis es una herramienta de asesoramiento cosmético y no constituye un diagnóstico médico. Para problemas de piel persistentes, consulta a un dermatólogo.",
  devTitle:"Panel técnico (solo demo)",
  devIntro:"Valores medidos sobre el fotograma, dentro de la elipse de la cara. En esta demo la puntuación se calcula en local con heurísticas de canvas; en producción estos mismos píxeles se enviarían a un endpoint que llama a un modelo de visión y devuelve el mismo esquema JSON.",
  devFoot:"Ninguna imagen sale del navegador en esta demo."
}};
/* ================================================================
   i18n — pensato per aggiungere lingue con un solo blocco
   --------------------------------------------------------------
   AGGIUNGERE UNA LINGUA (es. tedesco):
     1. registra il codice + nome qui sotto in LANGS
     2. aggiungi il blocco `de:{…}` in I18N e negli altri dizionari
        per-lingua (AXIS, STEPNAME, WHEN, ROLE, ISSUE, QUESTIONS,
        e le mappe inline in skinLabel / updateBadge / openCamera /
        runAnalysis / renderResult).
   Chiavi mancanti → fallback a DEFAULT_LANG, quindi una traduzione
   parziale degrada invece di rompersi. Il selettore in alto si
   genera da LANGS: non c'è HTML da toccare.

   IN PRODUZIONE la lingua segue lo storefront Shopify: la section
   Liquid inietta   <div id="…" data-app-lang="{{ request.locale.iso_code }}">
   e detectLang() la legge. Il cliente non vede il selettore (già
   sceglie la lingua dal language-switcher del negozio) — basta
   nascondere `.lang` via `SHOW_LANG_TOGGLE=false`. */
const LANGS = {
  it: "Italiano",
  en: "English",
  zh: "中文",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
};
const DEFAULT_LANG = "it";      // base di fallback per chiavi mancanti
const SHOW_LANG_TOGGLE = CFG.showToggle ?? true;  // false in produzione (segue lo storefront)

function detectLang(){
  const url  = new URLSearchParams(location.search).get("lang");
  const attr = ROOT.getAttribute("data-app-lang"); // Shopify
  const html = ROOT.getAttribute("data-app-lang");
  const raw  = String(url || attr || html || DEFAULT_LANG).toLowerCase();
  const base = raw.split("-")[0];   // zh-CN → zh, en-US → en, de-AT → de
  return LANGS[base] ? base : DEFAULT_LANG;
}
let LANG = detectLang();

// stringhe UI
const t = k => (I18N[LANG]?.[k] ?? I18N[DEFAULT_LANG][k] ?? k);
// mappe per-lingua (AXIS, STEPNAME, ROLE, …): stessa logica di fallback
const pick = map => (map[LANG] || map[DEFAULT_LANG]);

/* ================================================================
   Telemetria
   ---------------------------------------------------------------
   Tracciamento a livello utente: `visitor` persiste in localStorage
   fra sessioni (→ identifica la persona che torna), `session` copre
   un singolo test.

   Tre scelte non ovvie:
   - Ogni invio è fire-and-forget e avvolto in try/catch: un problema
     di rete nella telemetria non deve MAI interrompere il test del
     cliente. La misura è meno importante della cosa misurata.
   - `keepalive:true` perché gli eventi che contano di più (aggiunta
     al carrello) precedono di millisecondi un cambio di pagina, che
     altrimenti abortirebbe la richiesta.
   - Il timestamp NON lo manda il client: lo mette il Worker. Un
     orologio sbagliato lato browser è comunissimo e renderebbe la
     timeline inordinabile.

   Interruttore: CFG.track === false spegne tutto (utile se un giorno
   si aggancia a un banner di consenso). Senza workerUrl è già off. */
const rid = () => Math.random().toString(36).slice(2) + Date.now().toString(36);
const TRACK = {
  on: false, visitor: "", session: "",
  init(){
    this.on = !!String(CFG.workerUrl || "").trim() && CFG.track !== false;
    if(!this.on) return;
    /* Tablet di negozio: il dispositivo è condiviso, un visitor persistente
       fonderebbe tutti i clienti in una sola "persona". Id volatile. */
    if(CFG.kiosk){ this.visitor = rid(); }
    else try{
      let v = localStorage.getItem("eli_skt_vid");
      if(!v){ v = rid(); localStorage.setItem("eli_skt_vid", v); }
      this.visitor = v;
    } catch { this.visitor = rid(); }   // navigazione privata: id volatile
    this.session = rid();
  },
  /* In kiosk anche il visitor ruota a ogni nuovo test: sul tablet condiviso
     "nuova sessione" significa quasi sempre "nuova persona". */
  newSession(){ this.session = rid(); if(CFG.kiosk) this.visitor = rid(); },
  send(event, data){
    if(!this.on) return;
    try{
      const url = String(CFG.workerUrl).trim().replace(/\/+$/, "") + "/event";
      fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          /* channel dentro data → finisce nel payload JSON su D1, quindi
             /stats può distinguere negozio e web senza migrare lo schema. */
          event, data: { ...(data || {}), channel: CFG.kiosk ? "store" : "web" },
          visitor: this.visitor, session: this.session, lang: LANG,
          device: matchMedia("(max-width:767px)").matches ? "mobile" : "desktop"
        }),
        keepalive: true
      }).catch(()=>{});
    } catch {}
  }
};

function applyLang(){
  ROOT.setAttribute("data-lang", LANG);
  $$("[data-i]").forEach(el=>{ el.textContent = t(el.dataset.i); });
  $$(".lang button").forEach(b=>{
    b.setAttribute("aria-pressed", String(b.dataset.lang === LANG));
  });
  if(!$("#s-quiz").hidden) renderQuestion();
  if(!$("#s-res").hidden) renderResult();
  if(!$("#s-cam").hidden) updateBadge(lastGate);
  if(!$("#s-gate").hidden){ const db = STORE.read();
    if(db && db.history && db.history.length) showGate(db); }
}

/* selettore generato da LANGS — aggiungere una lingua non tocca l'HTML */
(function buildLangBar(){
  const bar = $(".lang");
  if(!bar) return;
  if(!SHOW_LANG_TOGGLE){ bar.hidden = true; return; }
  bar.innerHTML = Object.entries(LANGS).map(([code,name]) =>
    `<button data-lang="${code}" aria-pressed="${code===LANG}">${name}</button>`).join("");
  bar.querySelectorAll("button").forEach(b=>{
    b.onclick = ()=>{
      LANG = b.dataset.lang; applyLang();
      /* l'assistente vive nel layout kiosk: gli si passa la lingua
         dell'interfaccia. Le RISPOSTE seguono comunque la lingua in cui
         il cliente scrive, che può essere tutt'altra. */
      if(window.eliChat) window.eliChat.setLang(LANG);
    };
  });
})();

/* ================================================================
   Catalogo — prodotti reali ELI Cosmetics, tutti a magazzino
   (in produzione: fetch di /collections/<handle>/products.json
    o Storefront API, filtrando per i tag concern:*)
   ================================================================ */
const SHOP = CFG.shopUrl || "https://www.eli-cosmetics.com/products/";
const P_DEMO = [
 // ---- DETERGENTE ----
 {s:"detergente",b:"MIXSOON",n:"H.C.T Bubble Cleanser 150ml",p:29,h:"mixsoon-hct-bubble-cleanser",v:49086962237766,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/products/image_26c8962e-a0b0-42fc-95d6-3575c75e94e4.jpg?v=1706717549",
  c:{sebo:3,rughe:1}, age:16},
 {s:"detergente",b:"ILSO",n:"Sensitive Bubble Relaxing Cleanser 200g",p:45.6,h:"ilso-sensitive-bubble-relaxing-cleanser",v:54227591201094,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/ilso-sensitive-bubble-relaxing-cleanser_front_photo_original.jpg?v=1741621229",
  c:{rossore:3,idratazione:1}, age:18},
 {s:"detergente",b:"WETCODE",n:"Time Reversal Firming Facial Cleanser 120ml",p:21,h:"wetcode-time-reversal-firming-facial-cleanser",v:49086965973318,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/products/01_Time-Reversal-Firming-Facial-Cleanser-02-1.png?v=1757754992",
  c:{idratazione:2,rughe:2}, age:25},

 // ---- TONICO ----
 {s:"tonico",b:"SKIN1004",n:"Madagascar Centella Toning Toner 30ml",p:12,h:"skin1004-centella-toning-toner-30ml",v:53998797947206,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/skin1004-madagascar-centella-toning-toner-30ml.jpg?v=1755516728",
  c:{rughe:3,sebo:2}, age:16},
 {s:"tonico",b:"BEPLAIN",n:"Greenful Balancing Toner 200ml",p:29,h:"beplain-greenful-balancing-toner-200ml",v:49090582413638,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/beplain-greenful-balancing-toner_1024x1024_ef3afefc-1b3d-4298-bbfa-216708ab2cae.webp?v=1755695020",
  c:{sebo:3,rughe:1}, age:18},
 {s:"tonico",b:"MIXSOON",n:"Bean Toner 100ml",p:24,h:"mixsoon-bean-toner-100ml",v:53998052966726,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/XXL_p0200422652.webp?v=1737208463",
  c:{idratazione:3,rossore:1}, age:20},
 {s:"tonico",b:"SKIN1004",n:"Hyalu-Cica Brightening Toner 30ml",p:13,h:"skin1004-hyalu-cica-brightening-toner-30ml",v:53998906442054,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/OIP_2_40d62969-8266-4ad5-bba3-27a372c84efe.jpg?v=1737220139",
  c:{luminosita:3,idratazione:1}, age:16},
 {s:"tonico",b:"WETCODE",n:"Time Reversal Firming Skin Refining Toner 150ml",p:21,h:"wetcode-time-reversal-firming-skin-refining-toner",v:49086967513414,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/6268edc9ae357ae323326521211887a.jpg?v=1757755104",
  c:{rughe:3,idratazione:1}, age:25},

 // ---- SIERO / AMPOLLA ----
 {s:"siero",b:"SKIN1004",n:"Centella Poremizing Fresh Ampoule 50ml",p:24,h:"skin1004-centella-poreminzing-fresh-ampoule",v:49090455929158,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/skin1004-ampoule-serum-100ml-coming-soon-poremizing-fresh-ampoule-37221264851190_900x_95667863-9ede-468f-863e-68fd6715a267.webp?v=1706819637",
  c:{sebo:3,rughe:3}, age:25},
 {s:"siero",b:"BEPLAIN",n:"Cicaterol Ampoule 30ml",p:18,h:"beplain-cicaterol-ampoule-30ml",v:49683285705030,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/8809623941118-BEPLAIN-CICATEROL-AMPOULE-01.jpg?v=1755685643",
  c:{rossore:3,rughe:2,luminosita:1}, age:18},
 {s:"siero",b:"DEWYTREE",n:"Moisture Barrier Calming Ampoule 60ml",p:33,h:"dewytree-moisture-barrier-calming-ampoule-60ml",v:56456190198086,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/ACdeepmoisturebarriercalmingampoule.webp?v=1777373825",
  c:{idratazione:3,rossore:2,rughe:1}, age:18},

 // ---- CREMA ----
 {s:"crema",b:"MIXSOON",n:"Cica Hyal Deep Soothing Cream 50ml",p:27.9,h:"mixsoon-cica-hyal-deep-soothing-cream-50ml",v:55014013141318,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/e0af30198ba2190c0df5f12ac6c8f9bc.webp?v=1756729715",
  c:{rossore:3,idratazione:2}, age:18},
 {s:"crema",b:"WETCODE",n:"PRO Dual-Peptide Anti-Wrinkle Essence Cream",p:34,h:"wetcode-pro-anti-wrinkle-essence-cream",v:49086967775558,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/products/01_Dual-Peptide-Firming-Anti-Wrinkle-Essence-Cream-06.jpg?v=1706717636",
  c:{rughe:3,idratazione:2}, age:30},
 // (l'Emulsione Time Reversal è passata al passaggio "idratante",
 //  come da guida: le emulsioni sono lo step 9, non la crema)

 // ---- OCCHI ----
 {s:"occhi",b:"WETCODE",n:"Dual-Peptide Firming Anti-wrinkle Eye Cream 20ml",p:35,h:"wetcode-pro-anti-wrinkle-eye-cream",v:49090011103558,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/01-Dual_Peptide-Anti-Wrinkle-Eye-Cream-02.png?v=1706813142",
  c:{rughe:3}, age:25},
 {s:"occhi",b:"MIXSOON",n:"Bean Eye Cream 20ml",p:45,h:"mixsoon-bean-eye-cream-20ml",v:50495675760966,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/bean_eye_cream__21041.webp?v=1755604990",
  c:{luminosita:3,rughe:1}, age:16},

 // ---- PASSAGGI EXTRA del rituale in 10 (pool negozio) ----
 {s:"struccante",b:"SKIN1004",n:"Madagascar Centella Light Cleansing Oil 200ml",p:29.9,h:"skin1004-madagascar-centella-light-cleansing-oil",v:49086952669510,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/products/b002057_2.jpg?v=1706717324",
  c:{rossore:3}, age:18},
 {s:"struccante",b:"MIXSOON",n:"Collagen Cleansing Balm 50ml",p:34,h:"mixsoon-collagen-cleansing-balm-50ml",v:54585512657222,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/th.jpg?v=1748770731",
  c:{rughe:3,idratazione:2}, age:18},
 {s:"esfoliante",b:"HARUHARU WONDER",n:"Centella 3% PHA Gentle Liquid Exfoliating Serum 120ml",p:29.9,h:"haruharu-wonder-centella-3-pha-gentle-liquid-exfoliating-serum",v:54621882351942,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/centella_3_PHA_gentle_liquid_exfoliating_serum_120ml.webp?v=1749382037",
  c:{rossore:3,luminosita:2,sebo:2}, age:18},
 {s:"esfoliante",b:"ILSO",n:"Moringa Purifying Pore Pad 60pz",p:35,h:"ilso-moringa-purifying-pore-pad",v:54227509150022,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/OIP_f9518fb0-9c1a-4848-a471-ff624dcbec2c.webp?v=1759489098",
  c:{sebo:3,luminosita:2}, age:18},
 {s:"idratante",b:"WETCODE",n:"Time Reversal Firming Emulsion 120ml",p:28,h:"wetcode-time-reversal-firming-emulsion",v:49086965907782,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/1061fe2e4ebbfb71b9a80195a2f5396.jpg?v=1757755304",
  c:{rughe:3,idratazione:2}, age:25},
 {s:"idratante",b:"WETCODE",n:"Aqua Repair Emulsion 120ml",p:20,h:"wetcode-aqua-repair-emulsion",v:49086965547334,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/WETCODE-Aqua-Repair-Moisturizing-Emulsion-120ml-bottle.webp?v=1757001367",
  c:{idratazione:3}, age:18},

 // ---- SPF (sempre presente) ----
 {s:"spf",b:"MIXSOON",n:"Centella Sun Cream SPF50+ PA++++ 50g",p:25,h:"mixsoon-centella-suncream",v:49086963417414,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/products/image_0c461887-6a70-4d4c-a214-1b80a8c3852c.jpg?v=1706717566",
  c:{luminosita:2,sebo:1}, age:16},
 {s:"spf",b:"BEPLAIN",n:"Sunmuse Mineral Sunscreen SPF50+ PA++++ 50ml",p:25,h:"beplain-clean-ocean-nonnano-mild-sunscreen-spf-50-pa",v:49683318964550,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/s-l1600.webp?v=1755685479",
  c:{rossore:3,luminosita:1}, age:18},
 {s:"spf",b:"BEPLAIN",n:"Sunmuse Moisture Sunscreen SPF50+ PA++++ 50ml",p:29,h:"beplain-clean-ocean-moisture-sunscreen-50",v:49090582839622,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/BEPLAIN_Clean_Ocean_Moisture_Sunscreen_SPF50_PA.jpg?v=1735921202",
  c:{idratazione:3,luminosita:1}, age:18},

 // ---- BOOSTER SETTIMANALE ----
 {s:"booster",b:"SKIN1004",n:"Hyalu-Cica Hydrating Mask *5pz",p:20,h:"skin1004-hyalu-cica-hydrating-mask-5pz",v:54856385823046,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/skin1004-hyalu-cica-hydrating-mask-1123859799_1440x_f196e2be-e5e0-48df-b776-c6ffc8bbe6b9.webp?v=1753537368",
  c:{idratazione:3}, age:18},
 {s:"booster",b:"SKIN1004",n:"Tea-Trica Relaxing Mask *5pz",p:20.5,h:"skin1004-tea-trica-relaxing-mask-5pz",v:54856250196294,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/skin1004-madagascar-centella-tea-trica-relaxing-mask-1pc-846.jpg?v=1755506507",
  c:{sebo:3,rossore:2}, age:18},
 {s:"booster",b:"ILSO",n:"Heartleaf Tendersome Double Calming Pads 60pz",p:35,h:"ilso-heartleaf-tendersome-double-calming-pads-60pz",v:55195446706502,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/R_53855b9e-586f-4440-b2e4-7ddf25bfca95.jpg?v=1759485695",
  c:{rossore:3,rughe:2}, age:18},
 {s:"booster",b:"MIXSOON",n:"Centella Mask Pack *5pz",p:23,h:"mixsoon-centella-mask-pack",v:49086935302470,
  img:"https://cdn.shopify.com/s/files/1/0809/5573/6390/files/mixsoon-centella-mask-pack-25g-5pcs-136.jpg?v=1755784732",
  c:{luminosita:2,idratazione:2}, age:16},
];

/* ================================================================
   Pool prodotti: TAG-driven in produzione
   --------------------------------------------------------------
   In Shopify la sezione inietta window.ELI_SKT_PRODUCTS leggendo la
   collection 'skt-pool' (membership via tag skt-pool; step/concern/eta
   via tag skt-*). Cosi il pool si regola dai TAG in backend, senza
   toccare il codice. In standalone (questa demo) si ricade su P_DEMO.
   L'adapter riordina `c` per peso: il primo asse deve essere il primario
   (l'engine usa Object.keys(p.c)[0] per il bonus di focus). */
function sktFromInjected(raw){
  return raw.filter(o => o && o.s && o.v && o.h).map(o => {
    const c = {};
    Object.entries(o.c || {})
      .map(([k,w]) => [k, +w])
      .filter(([,w]) => w > 0)
      .sort((a,b) => b[1] - a[1])
      .forEach(([k,w]) => { c[k] = w; });
    return { s:o.s, b:o.b || "", n:o.n || "", p:+o.p || 0, h:o.h, v:+o.v,
             img:o.img || "", c, age:+o.age || 16, push:+o.push || 0 };
  });
}
const _sktInj = (typeof window !== "undefined" && window.ELI_SKT_PRODUCTS) || null;
const P = (_sktInj && _sktInj.length) ? sktFromInjected(_sktInj) : P_DEMO;
// solo demo: ?push=<handle> simula il tag skt-push-2 su un prodotto
if(CFG._demoPush){ const dp = P.find(x => x.h === CFG._demoPush); if(dp) dp.push = 2; }

/* ================================================================
   Assi di analisi
   ================================================================ */
const AXES = ["idratazione","sebo","rossore","luminosita","rughe"];

/* Alcuni obiettivi dichiarati non sono un singolo asse. "Acne" non è una
   dimensione a sé: la pelle a tendenza acneica ha bisogno di controllo del
   sebo/pori (BHA, argilla) E di lenire l'infiammazione (centella, tea tree).
   Perciò l'obiettivo "acne" si espande su DUE assi — sebo + rossore — che
   sono esattamente i tag dei prodotti giusti in catalogo (MIXSOON H.C.T al
   salicilico, SKIN1004 Poremizing, SKIN1004 Tea-Trica, BEPLAIN Cicaterol).
   Ogni altro obiettivo mappa su se stesso. */
/* "nd" = non lo so. Mappato esplicitamente su NESSUN asse: chi non sa cosa
   vuole migliorare non deve spostare i punteggi in nessuna direzione — a
   dirlo restano la foto e il tipo di pelle dichiarato. Nei dati del quiz
   precedente questa era il 20% delle risposte: non è un caso limite, ed
   erano persone costrette a tirare a indovinare (falsando il consiglio) o
   ad abbandonare. */
const GOAL_AXES = { acne: ["sebo","rossore"], nd: [] };
const goalAxes = g => GOAL_AXES[g] || [g];
const AXIS = {
 it:{
  idratazione:{l:"Idratazione", lo:"La barriera cutanea sembra disidratata: la pelle tira e assorbe subito le creme.", hi:"Barriera ben idratata, buona ritenzione d'acqua."},
  sebo:{l:"Sebo e pori", lo:"Zona T lucida e pori visibili: serve equilibrio, non aggressività.", hi:"Produzione di sebo equilibrata, pori poco visibili."},
  rossore:{l:"Rossore e sensibilità", lo:"Si notano arrossamenti diffusi: meglio formule lenitive e senza profumo.", hi:"Colorito uniforme, nessun segno evidente di reattività."},
  luminosita:{l:"Uniformità del colorito", lo:"Il colorito risulta poco uniforme, con zone più spente di altre: serve esfoliazione delicata e antiossidanti.", hi:"Colorito uniforme e luminoso."},
  rughe:{l:"Texture e linee sottili", lo:"La grana è irregolare e si intravedono linee sottili: peptidi e idratazione profonda.", hi:"Grana compatta, elasticità buona."}
 },
 en:{
  idratazione:{l:"Hydration", lo:"The skin barrier looks dehydrated: skin feels tight and drinks creams up instantly.", hi:"Well-hydrated barrier, good water retention."},
  sebo:{l:"Oil & pores", lo:"Shiny T-zone and visible pores: needs balance, not harshness.", hi:"Balanced oil production, pores barely visible."},
  rossore:{l:"Redness & sensitivity", lo:"Diffuse redness is visible: go for soothing, fragrance-free formulas.", hi:"Even tone, no clear signs of reactivity."},
  luminosita:{l:"Tone evenness", lo:"The complexion looks uneven, with some areas duller than others: needs gentle exfoliation and antioxidants.", hi:"Even, radiant complexion."},
  rughe:{l:"Texture & fine lines", lo:"Texture is uneven and fine lines show: peptides and deep hydration.", hi:"Smooth texture, good elasticity."}
 },
 zh:{
  idratazione:{l:"水润度", lo:"屏障偏缺水：容易紧绷，护肤品一抹就吸收干净。", hi:"屏障水分充足，锁水能力良好。"},
  sebo:{l:"出油与毛孔", lo:"T 区泛光、毛孔可见：需要控油平衡，而不是强力清洁。", hi:"油脂分泌平衡，毛孔不明显。"},
  rossore:{l:"泛红与敏感", lo:"有弥散性泛红：建议无香精的舒缓配方。", hi:"肤色均匀，没有明显敏感迹象。"},
  luminosita:{l:"肤色均匀度", lo:"肤色不够均匀，局部偏暗沉：需要温和去角质与抗氧化。", hi:"肤色均匀通透。"},
  rughe:{l:"肤质与细纹", lo:"肌理不够平整、有细纹迹象：需要胜肽与深层保湿。", hi:"肌理紧致，弹性良好。"}
 },
 de:{
  idratazione:{l:"Feuchtigkeit", lo:"Die Hautbarriere wirkt dehydriert: Die Haut spannt und saugt Cremes sofort auf.", hi:"Gut hydratisierte Barriere, gute Wasserbindung."},
  sebo:{l:"Talg & Poren", lo:"Glänzende T-Zone und sichtbare Poren: Es braucht Balance, keine Härte.", hi:"Ausgeglichene Talgproduktion, kaum sichtbare Poren."},
  rossore:{l:"Rötung & Empfindlichkeit", lo:"Diffuse Rötungen sind sichtbar: besser beruhigende, parfümfreie Formeln.", hi:"Ebenmäßiger Teint, keine deutlichen Zeichen von Reaktivität."},
  luminosita:{l:"Ebenmäßigkeit", lo:"Der Teint wirkt ungleichmäßig, stellenweise fahl: sanfte Exfoliation und Antioxidantien.", hi:"Ebenmäßiger, strahlender Teint."},
  rughe:{l:"Textur & feine Linien", lo:"Das Hautbild ist unregelmäßig, feine Linien zeichnen sich ab: Peptide und Tiefenfeuchtigkeit.", hi:"Feines Hautbild, gute Elastizität."}
 },
 fr:{
  idratazione:{l:"Hydratation", lo:"La barrière cutanée semble déshydratée : la peau tiraille et absorbe les crèmes instantanément.", hi:"Barrière bien hydratée, bonne rétention d'eau."},
  sebo:{l:"Sébum & pores", lo:"Zone T brillante et pores visibles : il faut de l'équilibre, pas de l'agressivité.", hi:"Production de sébum équilibrée, pores peu visibles."},
  rossore:{l:"Rougeurs & sensibilité", lo:"Des rougeurs diffuses sont visibles : privilégie des formules apaisantes et sans parfum.", hi:"Teint uniforme, aucun signe net de réactivité."},
  luminosita:{l:"Uniformité du teint", lo:"Le teint manque d'uniformité, avec des zones plus ternes : exfoliation douce et antioxydants.", hi:"Teint uniforme et lumineux."},
  rughe:{l:"Texture & ridules", lo:"Le grain de peau est irrégulier et des ridules apparaissent : peptides et hydratation en profondeur.", hi:"Grain de peau lisse, bonne élasticité."}
 },
 es:{
  idratazione:{l:"Hidratación", lo:"La barrera cutánea parece deshidratada: la piel tira y absorbe las cremas al instante.", hi:"Barrera bien hidratada, buena retención de agua."},
  sebo:{l:"Sebo y poros", lo:"Zona T brillante y poros visibles: hace falta equilibrio, no agresividad.", hi:"Producción de sebo equilibrada, poros poco visibles."},
  rossore:{l:"Rojeces y sensibilidad", lo:"Se aprecian rojeces difusas: mejor fórmulas calmantes y sin perfume.", hi:"Tono uniforme, sin signos claros de reactividad."},
  luminosita:{l:"Uniformidad del tono", lo:"El tono se ve poco uniforme, con zonas más apagadas que otras: exfoliación suave y antioxidantes.", hi:"Tono uniforme y luminoso."},
  rughe:{l:"Textura y líneas finas", lo:"La textura es irregular y se intuyen líneas finas: péptidos e hidratación profunda.", hi:"Textura fina, buena elasticidad."}
 }
};
const STEPNAME = {
 it:{struccante:"Olio detergente",detergente:"Detersione",esfoliante:"Esfoliante",tonico:"Tonico",siero:"Siero",crema:"Crema",occhi:"Contorno occhi",idratante:"Idratante",spf:"Protezione solare",booster:"Booster settimanale"},
 en:{struccante:"Oil cleanser",detergente:"Cleanser",esfoliante:"Exfoliator",tonico:"Toner",siero:"Serum",crema:"Cream",occhi:"Eye cream",idratante:"Moisturizer",spf:"Sunscreen",booster:"Weekly booster"},
 zh:{struccante:"卸妆油",detergente:"洁面",esfoliante:"去角质",tonico:"爽肤水",siero:"精华",crema:"面霜",occhi:"眼霜",idratante:"保湿乳",spf:"防晒",booster:"每周加强"},
 de:{struccante:"Reinigungsöl",detergente:"Reinigung",esfoliante:"Peeling",tonico:"Toner",siero:"Serum",crema:"Creme",occhi:"Augenpflege",idratante:"Feuchtigkeitspflege",spf:"Sonnenschutz",booster:"Wöchentlicher Booster"},
 fr:{struccante:"Huile démaquillante",detergente:"Nettoyant",esfoliante:"Exfoliant",tonico:"Tonique",siero:"Sérum",crema:"Crème",occhi:"Contour des yeux",idratante:"Hydratant",spf:"Protection solaire",booster:"Booster hebdomadaire"},
 es:{struccante:"Aceite desmaquillante",detergente:"Limpiador",esfoliante:"Exfoliante",tonico:"Tónico",siero:"Sérum",crema:"Crema",occhi:"Contorno de ojos",idratante:"Hidratante",spf:"Protección solar",booster:"Booster semanal"}
};
/* In negozio i nomi seguono la guida ufficiale (step 5 = Essence & Siero,
   step 7 = Maschera): override SOLO in kiosk, la versione web non cambia. */
const STEPNAME_KIOSK = {
 it:{siero:"Essence & Siero",crema:"Crema viso",booster:"Maschera"},
 en:{siero:"Essence & Serum",crema:"Face cream",booster:"Mask"},
 zh:{siero:"精华 / 安瓶",crema:"面霜",booster:"面膜"},
 de:{siero:"Essence & Serum",crema:"Gesichtscreme",booster:"Maske"},
 fr:{siero:"Essence & Sérum",crema:"Crème visage",booster:"Masque"},
 es:{siero:"Esencia & Sérum",crema:"Crema facial",booster:"Mascarilla"}
};
const stepName = s => (CFG.kiosk && pick(STEPNAME_KIOSK)[s]) || pick(STEPNAME)[s];

/* ================================================================
   Questionario
   ================================================================ */
const QUESTIONS = [
 {k:"age", multi:false,
  q:{it:"Quanti anni hai?", en:"How old are you?", zh:"你的年龄段？", de:"Wie alt bist du?", fr:"Quel âge as-tu ?", es:"¿Cuántos años tienes?"},
  hint:{it:"Serve a calibrare l'intensità degli attivi.", en:"Helps us calibrate how strong the actives should be.", zh:"用来决定活性成分的强度。", de:"Hilft uns, die Stärke der Wirkstoffe zu kalibrieren.", fr:"Sert à calibrer l'intensité des actifs.", es:"Sirve para calibrar la intensidad de los activos."},
  two:true,
  o:[{v:"18",l:{it:"Meno di 25",en:"Under 25",zh:"25 岁以下",de:"Unter 25",fr:"Moins de 25 ans",es:"Menos de 25"}},
     {v:"25",l:{it:"25 – 34",en:"25 – 34",zh:"25 – 34 岁",de:"25 – 34",fr:"25 – 34",es:"25 – 34"}},
     {v:"35",l:{it:"35 – 44",en:"35 – 44",zh:"35 – 44 岁",de:"35 – 44",fr:"35 – 44",es:"35 – 44"}},
     {v:"45",l:{it:"45 o più",en:"45 or older",zh:"45 岁以上",de:"45 oder älter",fr:"45 ans ou plus",es:"45 o más"}}]},
 {k:"type", multi:false,
  q:{it:"Come descriveresti la tua pelle?", en:"How would you describe your skin?", zh:"你觉得自己是什么肤质？", de:"Wie würdest du deine Haut beschreiben?", fr:"Comment décrirais-tu ta peau ?", es:"¿Cómo describirías tu piel?"},
  hint:{it:"Pensa a com'è a metà giornata, senza ritocchi.", en:"Think of how it looks mid-day, with no touch-ups.", zh:"想想中午不补妆时的状态。", de:"Denk daran, wie sie mittags aussieht, ohne Nachbessern.", fr:"Pense à son état en milieu de journée, sans retouches.", es:"Piensa en cómo está a media jornada, sin retoques."},
  two:true,
  o:[{v:"secca",l:{it:"Secca",en:"Dry",zh:"干性",de:"Trocken",fr:"Sèche",es:"Seca"},d:{it:"Tira, a volte desquama",en:"Tight, sometimes flaky",zh:"紧绷，偶尔起皮",de:"Spannt, schuppt manchmal",fr:"Tiraille, desquame parfois",es:"Tira, a veces se descama"}},
     {v:"normale",l:{it:"Normale",en:"Normal",zh:"中性",de:"Normal",fr:"Normale",es:"Normal"},d:{it:"Equilibrata, pochi fastidi",en:"Balanced, few concerns",zh:"平衡，问题不多",de:"Ausgeglichen, wenig Probleme",fr:"Équilibrée, peu de soucis",es:"Equilibrada, pocas molestias"}},
     {v:"mista",l:{it:"Mista",en:"Combination",zh:"混合性",de:"Mischhaut",fr:"Mixte",es:"Mixta"},d:{it:"Zona T lucida, guance normali",en:"Oily T-zone, normal cheeks",zh:"T 区出油，两颊正常",de:"Glänzende T-Zone, normale Wangen",fr:"Zone T brillante, joues normales",es:"Zona T brillante, mejillas normales"}},
     {v:"grassa",l:{it:"Grassa",en:"Oily",zh:"油性",de:"Ölig",fr:"Grasse",es:"Grasa"},d:{it:"Lucida ovunque entro sera",en:"Shiny all over by evening",zh:"到傍晚整脸泛光",de:"Glänzt bis zum Abend überall",fr:"Brille partout en fin de journée",es:"Brilla por todas partes al final del día"}},
     {v:"sensibile",l:{it:"Sensibile",en:"Sensitive",zh:"敏感",de:"Empfindlich",fr:"Sensible",es:"Sensible"},d:{it:"Reagisce spesso, si arrossa",en:"Reacts often, gets red",zh:"容易反应、发红",de:"Reagiert oft, wird rot",fr:"Réagit souvent, rougit",es:"Reacciona a menudo, se enrojece"}}]},
 {k:"goal", multi:true,
  q:{it:"Cosa vorresti migliorare?", en:"What would you like to improve?", zh:"你最想改善什么？", de:"Was möchtest du verbessern?", fr:"Que voudrais-tu améliorer ?", es:"¿Qué te gustaría mejorar?"},
  hint:{it:"Puoi scegliere fino a due priorità.", en:"You can pick up to two priorities.", zh:"最多选两项。", de:"Du kannst bis zu zwei Prioritäten wählen.", fr:"Tu peux choisir jusqu'à deux priorités.", es:"Puedes elegir hasta dos prioridades."},
  two:true,
  o:[{v:"idratazione",l:{it:"Secchezza",en:"Dryness",zh:"干燥缺水",de:"Trockenheit",fr:"Sécheresse",es:"Sequedad"}},
     {v:"sebo",l:{it:"Lucidità e pori",en:"Oil & pores",zh:"出油与毛孔",de:"Glanz & Poren",fr:"Brillance & pores",es:"Brillos y poros"}},
     {v:"acne",l:{it:"Brufoli e imperfezioni",en:"Breakouts & blemishes",zh:"痘痘与瑕疵",de:"Pickel & Unreinheiten",fr:"Boutons & imperfections",es:"Granitos e imperfecciones"}},
     {v:"rossore",l:{it:"Rossori",en:"Redness",zh:"泛红",de:"Rötungen",fr:"Rougeurs",es:"Rojeces"}},
     {v:"luminosita",l:{it:"Colorito spento",en:"Dull complexion",zh:"暗沉",de:"Fahler Teint",fr:"Teint terne",es:"Tono apagado"}},
     {v:"rughe",l:{it:"Linee sottili",en:"Fine lines",zh:"细纹",de:"Feine Linien",fr:"Ridules",es:"Líneas finas"}},
     /* Esclusiva rispetto alle altre (vedi handler di #q-opts): "non lo so"
        + "brufoli" è una contraddizione, non due priorità. */
     {v:"nd",l:{it:"Non lo so",en:"I'm not sure",zh:"我不确定",de:"Ich weiß nicht",fr:"Je ne sais pas",es:"No lo sé"},
      d:{it:"Lo capiamo noi dalla foto",en:"We'll work it out from your photo",zh:"交给我们，从照片判断",de:"Wir lesen es aus deinem Foto ab",fr:"On le déduit de ta photo",es:"Lo deducimos de tu foto"}}]}
];

/* ================================================================
   Stato + helper
   ================================================================ */

const clamp = (v,a,b) => Math.max(a, Math.min(b, v));
const eur = n => "€" + n.toFixed(2).replace(/\.00$/,"").replace(".", ",");

const S = { qi:0, ans:{goal:[]}, metrics:null, scores:null, plan:null, shot:null,
            camOnly:false, sel:null, selPlanRef:null };
let stream = null, gateTimer = null, lastGate = null;

const SCREENS = ["s-intro","s-quiz","s-cam","s-check","s-run","s-precap","s-gate","s-res"];
function show(id){
  if(id !== "s-cam") stopCamera();   // la webcam non deve restare accesa fuori dallo step foto
  SCREENS.forEach(x => { $("#"+x).hidden = (x !== id); });
  $("#"+id).classList.remove("fade"); void $("#"+id).offsetWidth; $("#"+id).classList.add("fade");
  window.scrollTo({top:0, behavior:"smooth"});
}

/* ================================================================
   STEP 1 — intro
   ================================================================ */
/* Il CTA principale non viene MAI disabilitato: un bottone grigio che non
   reagisce non dice all'utente cosa manca, ed è esattamente il punto in cui
   il flusso si interrompe. Il click c'è sempre, e se il consenso manca lo
   segnala in modo visibile. Il consenso resta comunque esplicito e opt-in. */
$("#consent").onchange = e => {
  if(e.target.checked){
    $("#consent-err").hidden = true;
    $("#consent-box").classList.remove("nag");
  }
};
$("#btn-start").onclick = () => {
  if(!$("#consent").checked){
    const box = $("#consent-box");
    $("#consent-err").hidden = false;
    box.classList.remove("nag"); void box.offsetWidth; box.classList.add("nag");
    box.scrollIntoView({block:"center", behavior:"smooth"});
    return;
  }
  S.camOnly = false; TRACK.newSession(); TRACK.send("start", { mode:"camera" }); startQuiz();
};
$("#btn-skipcam").onclick = () => {
  S.camOnly = true; TRACK.newSession(); TRACK.send("start", { mode:"quiz" }); startQuiz();
};

function startQuiz(){ S.qi = 0; show("s-quiz"); renderQuestion(); }

/* ================================================================
   STEP 2 — questionario
   ================================================================ */
function renderQuestion(){
  const Q = QUESTIONS[S.qi];
  $("#q-title").textContent = pick(Q.q);
  $("#q-hint").textContent  = pick(Q.hint);
  $("#q-opts").className = "opts" + (Q.two ? " two" : "");
  $("#q-opts").innerHTML = "";

  $$(".steps i").forEach((el,i)=> el.classList.toggle("on", i <= S.qi));

  Q.o.forEach(o => {
    const cur = S.ans[Q.k];
    const on  = Q.multi ? (cur||[]).includes(o.v) : cur === o.v;
    const b = document.createElement("button");
    b.className = "opt"; b.type = "button";
    b.setAttribute("aria-pressed", String(on));
    b.innerHTML = `<span class="dot"></span><span><b>${pick(o.l)}</b>${
      o.d ? `<small>${pick(o.d)}</small>` : ""}</span>`;
    b.onclick = () => {
      if(Q.multi){
        let a = S.ans[Q.k] || [];
        const i = a.indexOf(o.v);
        if(i >= 0) a.splice(i,1);
        else if(o.v === "nd") a = ["nd"];          // "non lo so" azzera il resto
        else {
          a = a.filter(x => x !== "nd");           // scegliere un problema toglie "non lo so"
          a.push(o.v); if(a.length > 2) a.shift();
        }
        S.ans[Q.k] = a;
      } else {
        S.ans[Q.k] = o.v;
      }
      renderQuestion();
    };
    $("#q-opts").appendChild(b);
  });

  const v = S.ans[Q.k];
  $("#q-next").disabled = Q.multi ? !(v && v.length) : !v;
  $("#q-next").textContent = (S.qi === QUESTIONS.length-1)
      ? (S.camOnly ? t("capCta") : t("goPhoto"))
      : t("navNext");
}
$("#q-back").onclick = () => { if(S.qi === 0) show("s-intro"); else { S.qi--; renderQuestion(); } };
$("#q-next").onclick = () => {
  /* Un evento per domanda risposta: confrontando i conteggi per `q` si
     legge direttamente dove le persone abbandonano il questionario. */
  const Q = QUESTIONS[S.qi];
  TRACK.send("answer", { q: Q.k, v: S.ans[Q.k] });
  if(S.qi < QUESTIONS.length-1){ S.qi++; renderQuestion(); return; }
  if(S.camOnly){ S.shot = null; S.metrics = null; runAnalysis(); }
  else openCamera();
};

/* ================================================================
   STEP 3 — fotocamera
   ================================================================ */
async function openCamera(){
  show("s-cam");
  $("#cam-err").hidden = true;
  try{
    stream = await navigator.mediaDevices.getUserMedia({
      video:{ facingMode:"user", width:{ideal:960}, height:{ideal:1280} }, audio:false
    });
    $("#video").srcObject = stream;
    await $("#video").play();
    $("#btn-shot").disabled = false;
    TRACK.send("camera_ok");
    gateTimer = setInterval(checkFrame, 450);
    checkFrame();
  }catch(err){
    /* Il tasso di camera_denied è la metrica di salute più importante del
       passo foto: se è alto, il problema non è il modello ma il contesto in
       cui la pagina viene aperta (webview, browser in-app). */
    TRACK.send("camera_error", { name: err.name });
    $("#stage").hidden = true;
    $("#s-cam").querySelector(".cam-actions").hidden = true;
    $("#cam-err").hidden = false;
    /* Distinguere il permesso negato dall'assenza di hardware: sono due
       problemi diversi e l'utente può risolvere solo il primo. Il caso
       "pannello incorporato che blocca la fotocamera" (webview, anteprima
       in-app, alcuni browser in-app di social) è il più frequente. */
    const denied = err.name === "NotAllowedError" || err.name === "SecurityError";
    const M = pick({
      it:{ denied:"L'accesso alla fotocamera è stato bloccato. Se stai vedendo questa pagina dentro un'app o un pannello di anteprima, aprila nel tuo browser; altrimenti consenti la fotocamera dall'icona nella barra degli indirizzi.",
           none:"Non è stata trovata nessuna fotocamera utilizzabile su questo dispositivo.",
           alt:" In alternativa puoi caricare una foto." },
      en:{ denied:"Camera access was blocked. If you're viewing this page inside an app or a preview panel, open it in your browser; otherwise allow the camera from the icon in the address bar.",
           none:"No usable camera was found on this device.",
           alt:" You can upload a photo instead." },
      zh:{ denied:"摄像头权限被拦截了。如果你是在某个 App 内置浏览器或预览面板里打开的，请改用系统浏览器打开；否则点地址栏的权限图标允许摄像头。",
           none:"这台设备上没有找到可用的摄像头。",
           alt:"　也可以直接上传一张自拍。" },
      de:{ denied:"Der Kamerazugriff wurde blockiert. Wenn du diese Seite in einer App oder Vorschau siehst, öffne sie im Browser; sonst erlaube die Kamera über das Symbol in der Adressleiste.",
           none:"Auf diesem Gerät wurde keine nutzbare Kamera gefunden.",
           alt:" Alternativ kannst du ein Foto hochladen." },
      fr:{ denied:"L'accès à la caméra a été bloqué. Si tu vois cette page dans une app ou un panneau d'aperçu, ouvre-la dans ton navigateur ; sinon autorise la caméra via l'icône de la barre d'adresse.",
           none:"Aucune caméra utilisable n'a été trouvée sur cet appareil.",
           alt:" Tu peux aussi importer une photo." },
      es:{ denied:"El acceso a la cámara ha sido bloqueado. Si estás viendo esta página dentro de una app o un panel de vista previa, ábrela en tu navegador; si no, permite la cámara desde el icono de la barra de direcciones.",
           none:"No se ha encontrado ninguna cámara utilizable en este dispositivo.",
           alt:" También puedes subir una foto." }
    });
    $("#cam-err-msg").textContent = (denied ? M.denied : M.none) + M.alt + "  (" + err.name + ")";
  }
}
function stopCamera(){
  if(gateTimer){ clearInterval(gateTimer); gateTimer = null; }
  if(stream){ stream.getTracks().forEach(x=>x.stop()); stream = null; }
}

/* --- controllo qualità in tempo reale --- */
const gaugeCv = document.createElement("canvas"); gaugeCv.width = 96; gaugeCv.height = 128;
function checkFrame(){
  const v = $("#video");
  if(!v.videoWidth) return;
  const g = gaugeCv.getContext("2d", {willReadFrequently:true});
  g.drawImage(v, 0, 0, gaugeCv.width, gaugeCv.height);
  const d = g.getImageData(24, 26, 48, 70).data;   // centro ≈ area del viso
  let sum = 0, n = 0;
  for(let i=0;i<d.length;i+=4){ sum += 0.299*d[i] + 0.587*d[i+1] + 0.114*d[i+2]; n++; }
  const L = sum/n;
  let gate;
  if(L < 55)       gate = "dark";
  else if(L > 205) gate = "bright";
  else             gate = "ok";
  updateBadge(gate);
}
function updateBadge(gate){
  lastGate = gate;
  const b = $("#cam-badge");
  const M = pick({
    it:{dark:"Troppo buio — cerca una finestra", bright:"Troppa luce diretta — spostati un po'", ok:"Luce perfetta — sei pronta"},
    en:{dark:"Too dark — find a window", bright:"Too much direct light — move a little", ok:"Perfect light — you're ready"},
    zh:{dark:"太暗了 — 靠近窗户试试", bright:"光太强了 — 稍微避开直射", ok:"光线正好 — 可以拍了"},
    de:{dark:"Zu dunkel — such dir ein Fenster", bright:"Zu viel direktes Licht — geh etwas weg", ok:"Perfektes Licht — bereit"},
    fr:{dark:"Trop sombre — rapproche-toi d'une fenêtre", bright:"Trop de lumière directe — décale-toi un peu", ok:"Lumière parfaite — c'est bon"},
    es:{dark:"Demasiado oscuro — acércate a una ventana", bright:"Demasiada luz directa — apártate un poco", ok:"Luz perfecta — todo listo"}
  });
  b.textContent = M[gate] || "…";
  b.className = "badge" + (gate === "ok" ? " good" : " warn");
  $("#btn-shot").disabled = false;   // non blocchiamo: avvisiamo soltanto
}

/* --- scatto con countdown --- */
$("#btn-shot").onclick = () => {
  $("#btn-shot").disabled = true;
  let k = 3;
  const c = $("#count"); c.hidden = false; c.textContent = k;
  const iv = setInterval(()=>{
    k--;
    if(k > 0){ c.textContent = k; }
    else { clearInterval(iv); c.hidden = true; capture(); }
  }, 800);
};

function capture(){
  const v = $("#video");
  const cv = document.createElement("canvas");
  // ritaglio verticale 3:4 centrato, coerente con l'ellisse guida
  const srcAR = v.videoWidth / v.videoHeight, dstAR = 3/4;
  let sw = v.videoWidth, sh = v.videoHeight, sx = 0, sy = 0;
  if(srcAR > dstAR){ sw = v.videoHeight * dstAR; sx = (v.videoWidth - sw)/2; }
  else             { sh = v.videoWidth / dstAR;  sy = (v.videoHeight - sh)/2; }
  cv.width = 300; cv.height = 400;
  cv.getContext("2d").drawImage(v, sx, sy, sw, sh, 0, 0, 300, 400);
  stopCamera();
  S.shot = cv;
  showCheck();
}

/* --- conferma dello scatto: prima non c'era modo di rifare la foto,
       si finiva dritti nell'analisi anche con uno scatto mosso --- */
function showCheck(){
  const st = $("#check-stage");
  st.innerHTML = "";
  const view = document.createElement("canvas");
  view.className = "shot"; view.width = 300; view.height = 400;
  view.getContext("2d").drawImage(S.shot, 0, 0);
  view.style.transform = "none";          // lo scatto è già speculare
  st.appendChild(view);

  const m = measure(S.shot);
  const w = $("#check-warn");
  let key = null;
  if(m){
    if(m.meanL < 62)        key = "warnDark";
    else if(m.meanL > 202)  key = "warnBright";
    else if(m.texture < 0.012) key = "warnFlat";
  }
  w.hidden = !key;
  w.dataset.i = key || "";
  if(key) w.textContent = t(key);

  show("s-check");
}
$("#btn-retake").onclick   = () => openCamera();
$("#btn-usephoto").onclick = () => runAnalysis();

function loadFile(input){
  const f = input.files && input.files[0];
  if(!f) return;
  const img = new Image();
  img.onload = () => {
    const cv = document.createElement("canvas");
    const srcAR = img.width/img.height, dstAR = 3/4;
    let sw = img.width, sh = img.height, sx = 0, sy = 0;
    if(srcAR > dstAR){ sw = img.height*dstAR; sx = (img.width-sw)/2; }
    else             { sh = img.width/dstAR;  sy = (img.height-sh)/2; }
    cv.width = 300; cv.height = 400;
    const cx = cv.getContext("2d");
    cx.translate(300,0); cx.scale(-1,1);          // stessa "specchiatura" dello scatto
    cx.drawImage(img, sx, sy, sw, sh, 0, 0, 300, 400);
    URL.revokeObjectURL(img.src);
    stopCamera();
    S.shot = cv;
    showCheck();
  };
  img.src = URL.createObjectURL(f);
}
$("#file").onchange  = e => loadFile(e.target);
$("#file2").onchange = e => loadFile(e.target);
$("#btn-quizonly").onclick = () => { stopCamera(); S.shot = null; S.metrics = null; runAnalysis(); };

/* ================================================================
   MOTORE — misure sull'immagine
   --------------------------------------------------------------
   In produzione questo blocco viene sostituito da:
     POST /api/skin  { image: <base64> }
       → Cloudflare Worker → modello vision (structured output)
       → { idratazione:0-100, sebo:…, rossore:…, luminosita:…, rughe:… }
   Le euristiche qui sotto servono a far vedere che il risultato
   reagisce davvero alla foto, senza bisogno di backend.
   ================================================================ */
function measure(cv){
  const W = cv.width, H = cv.height;
  const d = cv.getContext("2d", {willReadFrequently:true}).getImageData(0,0,W,H).data;
  const gray = new Float32Array(W*H);
  const cx = W*0.5, cy = H*0.46, rx = W*0.26, ry = H*0.255;

  let n=0, sL=0, sR=0, sG=0, sB=0, sSat=0;
  const ery = [];                       // indice di eritema per pixel, dentro il viso
  for(let y=0;y<H;y++) for(let x=0;x<W;x++){
    const i = (y*W+x)*4, r=d[i], g=d[i+1], b=d[i+2];
    const l = 0.299*r + 0.587*g + 0.114*b;
    gray[y*W+x] = l;
    const u=(x-cx)/rx, v=(y-cy)/ry;
    if(u*u+v*v <= 1){
      n++; sL+=l; sR+=r; sG+=g; sB+=b;
      const mx=Math.max(r,g,b), mn=Math.min(r,g,b);
      sSat += mx ? (mx-mn)/mx : 0;
      ery.push((r + 1) / (g + 1));       // R/G: proxy dell'emoglobina
    }
  }
  if(!n) return null;
  const meanL = sL/n, meanSat = sSat/n;
  const redRaw = (sR/n) - ((sG/n) + (sB/n))/2;

  /* Rossore misurato SUL SOGGETTO, non in assoluto.
     R−(G+B)/2 dipende quasi solo dal fototipo: su qualunque incarnato
     sano vale 40–65, quindi non distingue nulla. Confrontiamo invece
     le zone più rosse (p90) con la base del soggetto (mediana): così la
     misura è indipendente dal tono della pelle. */
  ery.sort((a,b)=>a-b);
  const p50 = ery[Math.floor(ery.length*0.50)];
  const p90 = ery[Math.floor(ery.length*0.90)];
  const erySpread = p50 ? (p90 - p50) / p50 : 0;

  // deviazione standard + frazione di pixel speculari (lucidità)
  let varAcc=0, spec=0, gradAcc=0, gn=0;
  for(let y=0;y<H;y++) for(let x=0;x<W;x++){
    const u=(x-cx)/rx, v=(y-cy)/ry;
    if(u*u+v*v > 1) continue;
    const l = gray[y*W+x];
    varAcc += (l-meanL)*(l-meanL);
    if(x+1<W && y+1<H){
      gradAcc += Math.abs(l-gray[y*W+x+1]) + Math.abs(l-gray[(y+1)*W+x]);
      gn++;
    }
  }
  const sd = Math.sqrt(varAcc/n);
  /* Soglia a 2.2σ: sotto (1.45σ) una distribuzione normale darebbe già
     ~7% di pixel "lucidi" su qualunque viso, quindi tutti risulterebbero
     grassi. A 2.2σ una pelle opaca sta sotto l'1,5% e solo i veri riflessi
     speculari (zona T lucida) generano la coda che ci interessa. */
  for(let y=0;y<H;y++) for(let x=0;x<W;x++){
    const u=(x-cx)/rx, v=(y-cy)/ry;
    if(u*u+v*v > 1) continue;
    if(gray[y*W+x] > meanL + 2.2*sd) spec++;
  }
  const shine   = spec/n;
  const texture = gn ? (gradAcc/gn) / Math.max(meanL, 1) : 0;

  // uniformità su blocchi 10×10 dentro il bounding box del viso
  const bx0=Math.round(cx-rx), by0=Math.round(cy-ry), bw=Math.round(rx*2), bh=Math.round(ry*2);
  const blocks=[];
  for(let by=0; by<10; by++) for(let bx=0; bx<10; bx++){
    let s=0, c=0;
    for(let y=by0+Math.round(by*bh/10); y<by0+Math.round((by+1)*bh/10); y++)
    for(let x=bx0+Math.round(bx*bw/10); x<bx0+Math.round((bx+1)*bw/10); x++){
      if(x<0||y<0||x>=W||y>=H) continue;
      const u=(x-cx)/rx, v=(y-cy)/ry;
      if(u*u+v*v > 1) continue;
      s += gray[y*W+x]; c++;
    }
    if(c > 20) blocks.push(s/c);
  }
  const bMean = blocks.reduce((a,b)=>a+b,0) / (blocks.length||1);
  const bSd   = Math.sqrt(blocks.reduce((a,b)=>a+(b-bMean)*(b-bMean),0) / (blocks.length||1));
  const uneven = bSd / Math.max(bMean,1);

  /* Verdetto sulla leggibilità dello scatto. Senza questo controllo una
     foto nera o bruciata produce texture ≈ 0 e quindi punteggi altissimi:
     lo scatto peggiore otterrebbe il risultato migliore. Se la foto non è
     leggibile i punteggi vanno costruiti sul solo questionario, dicendolo. */
  const usable = meanL >= 62 && meanL <= 202 && texture >= 0.012;

  return {
    usable, meanL, meanSat, redRaw, erySpread, shine, texture, uneven, sd,
    // valori normalizzati 0–1 (0 = ottimo, 1 = critico) — tutti relativi
    // al soggetto stesso, quindi indipendenti dal fototipo.
    nRed:    clamp((erySpread - 0.045) / 0.090, 0, 1),
    nShine:  clamp((shine    - 0.012) / 0.055, 0, 1),
    nTex:    clamp((texture  - 0.028) / 0.075, 0, 1),
    nUneven: clamp((uneven   - 0.055) / 0.085, 0, 1)
  };
}

/* --- punteggi: immagine (peso 0.62) + questionario (0.38) --- */
function computeScores(m){
  const age = parseInt(S.ans.age || "25", 10);
  const ty  = S.ans.type || "mista";
  const goals = S.ans.goal || [];

  let s;
  if(m){
    s = {
      /* Una foto NON misura l'acqua nella pelle. Misura la grana: la
         disidratazione si legge come micro-texture crepata. La lucidità
         non entra qui — è sebo, non idratazione, e legarla all'idratazione
         farebbe risultare "ben idratata" proprio la pelle grassa disidratata,
         che è il caso più frequente. Il resto lo porta il questionario. */
      idratazione: 100 - 74*m.nTex,
      sebo:        100 - 72*(0.62*m.nShine + 0.38*m.nTex),
      rossore:     100 - 78*m.nRed,
      // "uniformità del colorito": guidata dalla disomogeneità a blocchi,
      // NON dalla saturazione media (che dipende dal fototipo e finirebbe
      // per dire a chi ha la pelle più scura che è "meno luminosa").
      luminosita:  100 - 70*(0.65*m.nUneven + 0.35*m.nRed),
      rughe:       100 - 66*(0.60*m.nTex + 0.40*m.nUneven)
    };
  } else {
    s = { idratazione:72, sebo:72, rossore:72, luminosita:72, rughe:72 };
  }

  // auto-dichiarazione
  const TY = {
    secca:     {idratazione:-22, sebo:+10, rughe:-6},
    mista:     {sebo:-10, idratazione:-4},
    grassa:    {sebo:-22, idratazione:+8, luminosita:-4},
    sensibile: {rossore:-22, idratazione:-8}
  }[ty] || {};
  for(const k in TY) s[k] += TY[k];

  // età
  if(age >= 45)      { s.rughe -= 20; s.luminosita -= 9;  s.idratazione -= 7; }
  else if(age >= 35) { s.rughe -= 12; s.luminosita -= 5;  s.idratazione -= 4; }
  else if(age <= 18) { s.rughe += 9;  s.sebo -= 6; }

  // priorità dichiarate
  goals.forEach(g => goalAxes(g).forEach(ax => { if(s[ax] != null) s[ax] -= 13; }));

  AXES.forEach(k => s[k] = Math.round(clamp(s[k], 31, 92)));
  return s;
}

/* --- costruzione routine --- */
function buildPlan(scores){
  const age = parseInt(S.ans.age || "25", 10);
  const need = {};                                   // 0..1, quanto pesa ogni asse
  AXES.forEach(k => need[k] = clamp((80 - scores[k]) / 45, 0, 1));

  /* Il tipo di pelle dichiarato è un tratto CRONICO; la foto misura un
     singolo istante. Chi dice "sensibile" ha la pelle reattiva anche nel
     giorno in cui non è arrossata — quindi la dichiarazione impone un
     bisogno MINIMO che lo scatto può alzare ma non azzerare. Senza questo
     pavimento una foto pulita portava il bisogno di "rossore" a 0.04 e la
     routine ignorava del tutto quello che la persona aveva appena detto. */
  const FLOOR_BY_TYPE = {
    secca:     {idratazione:0.55},
    grassa:    {sebo:0.55},
    mista:     {sebo:0.35},
    sensibile: {rossore:0.55, idratazione:0.30}
  }[S.ans.type] || {};
  for(const k in FLOOR_BY_TYPE) need[k] = Math.max(need[k], FLOOR_BY_TYPE[k]);

  const goals = S.ans.goal || [];
  goals.forEach(g => goalAxes(g).forEach(ax => need[ax] = clamp(need[ax] + 0.35, 0, 1.35)));

  const ranked = [...AXES].sort((a,b) => need[b] - need[a]);
  const focus  = ranked.slice(0, 2);

  /* Due ordini possibili:
     - ORDER10 = il rituale coreano della guida ufficiale del negozio
       (/pages/korean-skincare-routine): oil cleanser → water cleanser →
       esfoliazione → tonico → essence/siero/ampolla (un solo passaggio) →
       crema viso → maschera → occhi → idratante → SPF.
     - ORDER7  = i 7 passaggi storici della versione online (booster in
       coda), per non cambiare nulla sul sito.
     Si sceglie dal POOL, non dalla config: se il pool contiene i passaggi
     estesi si segue la guida, altrimenti l'ordine storico. */
  const ORDER10 = ["struccante","detergente","esfoliante","tonico","siero",
                   "crema","booster","occhi","idratante","spf"];
  const ORDER7  = ["detergente","tonico","siero","crema","occhi","spf","booster"];
  const EXT = ["struccante","esfoliante","idratante"];
  const order = P.some(p => EXT.includes(p.s)) ? ORDER10 : ORDER7;
  const used = new Set();
  const plan = [];
  const PER_STEP = Math.max(1, Math.min(3, CFG.perStep ?? 1));

  order.forEach(step => {
    /* Online il contorno occhi si salta per i giovani senza segni — è un
       consiglio, non un rituale. In negozio NO: i 10 passaggi della guida
       sono fissi, una riga vuota sembra un errore del sistema. */
    if(step === "occhi" && age < 25 && scores.rughe > 62 && !CFG.kiosk) return;
    let cands = P.filter(p => p.s === step && p.age <= age + 4 && !used.has(p.h));
    /* Kiosk: se il filtro età svuota il passaggio, meglio proporre il
       prodotto della fascia d'età più vicina che lasciare il buco. */
    if(!cands.length && CFG.kiosk) cands = P.filter(p => p.s === step && !used.has(p.h));
    if(!cands.length) return;
    /* Punteggio in due parti tenute separate di proposito:
       `fit` = quanto il prodotto risponde alla pelle di questa persona;
       il bonus commerciale entra SOLO se il fit supera una soglia minima.
       Senza quella soglia, un marchio in esclusiva finirebbe consigliato
       anche a chi non ne ha bisogno — un'ottima routine per il margine e
       pessima per il cliente, che è il modo più rapido di bruciare la
       fiducia su cui si regge tutto lo strumento. */
    const scored = cands.map(p => {
      let fit = 0;
      for(const k in p.c) fit += p.c[k] * (need[k] || 0);
      if(focus.includes(Object.keys(p.c)[0])) fit += 0.4;
      return { p, fit };
    });
    const bestFit = Math.max(...scored.map(s => s.fit));
    const FLOOR = Math.max(0.35, bestFit * 0.55);   // niente spinta sotto questa soglia

    const TIER_W = CFG.tierWeight ?? 0.42;   // forza del bonus commerciale

    /* Bonus commerciale: online spinge i marchi esclusivi (tierOf); in
       negozio (CFG.priceTier) spinge il prodotto di fascia più alta del
       passaggio — stessa scala 0/1/2, stessa protezione: il bonus entra
       SOLO sopra la soglia di idoneità, mai al posto della pelle. */
    let commTier = tierOf;
    if(CFG.priceTier){
      const prices = cands.map(p => p.p);
      const pMin = Math.min(...prices), pMax = Math.max(...prices);
      const span = pMax - pMin;
      commTier = p => {
        if(span < 0.5) return 0;                 // prezzi piatti: nessuna spinta
        const t = (p.p - pMin) / span;
        return t >= 0.62 ? 2 : t >= 0.30 ? 1 : 0;
      };
    }

    /* Spinta manuale (tag skt-push-1/2, eventualmente con scadenza nel
       tag): il negozio decide cosa mettere in vetrina questa settimana.
       Passa dallo STESSO cancello di idoneità del bonus commerciale —
       un prodotto in promozione non adatto alla pelle resta fuori. */
    const PUSH_W = CFG.pushWeight ?? 0;

    scored.forEach(s => {
      let sc = s.fit;
      if(s.fit >= FLOOR){                               // bonus solo a parità di idoneità
        sc += commTier(s.p) * TIER_W;
        sc += (s.p.push || 0) * PUSH_W;
      }
      /* la leggera preferenza al prezzo basso esiste solo online: in
         negozio remerebbe contro la spinta alla fascia alta */
      if(!CFG.priceTier) sc -= s.p.p / 400;
      s.sc = sc;
    });
    scored.sort((a,b) => b.sc - a.sc);

    /* PER_STEP proposte per passaggio (negozio = 2): la prima è il
       consiglio, le successive sono alternative (alt:true) — devono
       comunque superare la soglia di idoneità, altrimenti meglio una
       proposta sola che una scelta riempitiva. */
    scored.slice(0, PER_STEP).forEach((s, i) => {
      if(i > 0 && s.fit < FLOOR) return;
      used.add(s.p.h);
      plan.push({...s.p, core: CORE.includes(step), alt: i > 0, _need: need});
    });
  });
  /* `order` esce insieme al piano: la colonna "Step N" del negozio numera
     secondo la guida, non secondo le righe effettivamente renderizzate. */
  return { plan, focus, need, order };
}

/* ================================================================
   Posizione competitiva del marchio
   --------------------------------------------------------------
   2 = di fatto esclusivo sul mercato italiano (nessun altro lo vende):
       una routine costruita su questi marchi NON è trasferibile — il
       cliente non può comprarla altrove, quindi il consiglio non
       regala margine alla concorrenza.
   1 = nessuna esclusiva, ma costo d'acquisto favorevole.
   0 = reperibile ovunque senza vantaggio: non lo spingiamo.
   ================================================================ */
const TIER = { WETCODE:2, DEWYTREE:2, BEPLAIN:1, MIXSOON:1, SKIN1004:1 };
const tierOf = p => TIER[p.b] || 0;

/* Sconto per NUMERO di prodotti selezionati, non più per "tier" fisso.
   Sotto i 3 non c'è sconto: la soglia spinge a costruire una routine vera
   invece di prendere un pezzo solo, e più prodotti = sconto maggiore.
   ⚠️ In Shopify questo diventa un codice sconto reale con condizione
   "quantità minima 3" + "solo categoria skincare": così lo sconto compare
   nel carrello e al checkout, e sparisce da solo se si scende sotto 3. */
/* Scaglioni sconto (percentuali) sovrascrivibili dall'editor tema:
   CFG.disc = { min:3, d34:0.08, d56:0.12, d7:0.15 }. Sotto la soglia `min`
   nessuno sconto. */
const DISC = CFG.disc || {};
const DISC_MIN = DISC.min ?? 3;
function discountFor(count){
  if(count < DISC_MIN) return 0;
  if(count <= 4) return DISC.d34 ?? 0.08;
  if(count <= 6) return DISC.d56 ?? 0.12;
  return DISC.d7 ?? 0.15;
}
const FREE_SHIP = CFG.freeShip ?? 59;

/* Storico locale. In produzione questo diventa un metafield sul cliente
   Shopify; qui localStorage riproduce esattamente lo stesso flusso.
   In kiosk lo storage è un no-op: sul tablet condiviso lo "storico"
   apparterrebbe al cliente precedente — niente gate account, niente
   confronto col test passato, e il pre-capture non viene mai saltato. */
const STORE = CFG.kiosk ? {
  read(){ return null; }, write(){}, clear(){}
} : {
  read(){ try { return JSON.parse(localStorage.getItem("eli_skin") || "null"); }
          catch { return null; } },
  write(v){ try { localStorage.setItem("eli_skin", JSON.stringify(v)); } catch {} },
  clear(){ try { localStorage.removeItem("eli_skin"); } catch {} }
};
const DATE_LOCALE = { it:"it-IT", en:"en-GB", zh:"zh-CN", de:"de-DE", fr:"fr-FR", es:"es-ES" };
const fmtDate = ts => new Date(ts).toLocaleDateString(
  DATE_LOCALE[LANG] || "it-IT", {day:"numeric", month:"long"});

/* I 4 passaggi che da soli fanno il 90% del risultato. Il resto è
   upsell legittimo, ma proporre 7 prodotti (≈€195) come unica opzione
   a chi non ti conosce ancora fa scappare il carrello. */
const CORE = ["detergente","siero","crema","spf"];
/* I 7 passaggi della routine "completa" storica (versione online). Il
   rituale in 10 aggiunge doppia detersione, esfoliazione e idratante —
   passaggi presenti solo dove il pool li copre (versione negozio). */
const FULL7 = ["detergente","tonico","siero","crema","occhi","spf","booster"];
const WHEN = {
  struccante:"PM", detergente:"AM · PM",
  esfoliante:{it:"PM · 1-2×/sett.", en:"PM · 1-2×/week", zh:"PM · 每周1-2次", de:"PM · 1-2×/Woche", fr:"PM · 1-2×/sem.", es:"PM · 1-2×/sem."},
  tonico:"AM · PM", siero:"AM · PM", crema:"AM · PM",
  occhi:"PM", idratante:"AM · PM", spf:"AM",
  booster:{it:"PM · 2×/sett.", en:"PM · 2×/week", zh:"PM · 每周2次", de:"PM · 2×/Woche", fr:"PM · 2×/sem.", es:"PM · 2×/sem."}
};
const whenOf = s => (typeof WHEN[s] === "string" ? WHEN[s] : pick(WHEN[s]));

/* La motivazione si costruisce combinando il RUOLO del passaggio con il
   PROBLEMA che quel prodotto affronta. Con una frase per solo problema,
   due prodotti che curano la stessa cosa (p.es. detergente e siero
   idratanti) finivano per mostrare una motivazione identica, e la scheda
   sembrava rotta. `taken` evita inoltre di ripetere lo stesso problema
   quando il prodotto ne copre più di uno. */
const ROLE = {
 it:{struccante:"Scioglie trucco, SPF e sebo: la prima metà della doppia detersione.",
     esfoliante:"Rimuove le cellule morte e riattiva la luminosità, 1-2 volte a settimana.",
     idratante:"Lo strato finale leggero che blocca l'idratazione.",
     detergente:"Deterge senza intaccare la barriera.", tonico:"Prepara la pelle al passaggio successivo.",
     siero:"È il passaggio più concentrato della routine.", crema:"Sigilla tutto e trattiene l'idratazione.",
     occhi:"Zona più sottile, formula dedicata.", spf:"Il passaggio che protegge i risultati di tutti gli altri.",
     booster:"Trattamento d'urto, due volte a settimana."},
 en:{struccante:"Melts away makeup, SPF and sebum: the first half of the double cleanse.",
     esfoliante:"Sweeps away dead cells to revive glow, 1-2 times a week.",
     idratante:"The light final layer that locks hydration in.",
     detergente:"Cleanses without stripping the barrier.", tonico:"Preps the skin for the next step.",
     siero:"The most concentrated step of the routine.", crema:"Seals everything in and locks in hydration.",
     occhi:"Thinnest area, dedicated formula.", spf:"The step that protects the results of all the others.",
     booster:"Intensive treatment, twice a week."},
 zh:{struccante:"溶解彩妆、防晒和油脂：二次清洁的第一步。",
     esfoliante:"去除老废角质，每周1-2次唤醒光泽。",
     idratante:"轻薄的最后一层，把水分锁住。",
     detergente:"温和清洁，不破坏屏障。", tonico:"为后续步骤打底。",
     siero:"整套里浓度最高的一步。", crema:"封住前面的成分，锁住水分。",
     occhi:"眼周皮肤最薄，需要专用配方。", spf:"保护其他所有步骤成果的一步。",
     booster:"每周两次的强化护理。"},
 de:{struccante:"Löst Make-up, SPF und Talg: die erste Hälfte der Doppelreinigung.",
     esfoliante:"Entfernt abgestorbene Zellen und weckt den Glow, 1-2× pro Woche.",
     idratante:"Die leichte letzte Schicht, die die Feuchtigkeit einschließt.",
     detergente:"Reinigt, ohne die Barriere anzugreifen.", tonico:"Bereitet die Haut auf den nächsten Schritt vor.",
     siero:"Der konzentrierteste Schritt der Routine.", crema:"Versiegelt alles und hält die Feuchtigkeit.",
     occhi:"Dünnste Hautpartie, eigene Formel.", spf:"Der Schritt, der die Ergebnisse aller anderen schützt.",
     booster:"Intensivpflege, zweimal pro Woche."},
 fr:{struccante:"Dissout maquillage, SPF et sébum : la première moitié du double nettoyage.",
     esfoliante:"Élimine les cellules mortes et ravive l'éclat, 1-2 fois par semaine.",
     idratante:"La dernière couche légère qui scelle l'hydratation.",
     detergente:"Nettoie sans agresser la barrière.", tonico:"Prépare la peau à l'étape suivante.",
     siero:"L'étape la plus concentrée de la routine.", crema:"Scelle le tout et retient l'hydratation.",
     occhi:"Zone la plus fine, formule dédiée.", spf:"L'étape qui protège les résultats de toutes les autres.",
     booster:"Soin intensif, deux fois par semaine."},
 es:{struccante:"Disuelve maquillaje, SPF y sebo: la primera mitad de la doble limpieza.",
     esfoliante:"Elimina las células muertas y reaviva la luminosidad, 1-2 veces por semana.",
     idratante:"La última capa ligera que sella la hidratación.",
     detergente:"Limpia sin dañar la barrera.", tonico:"Prepara la piel para el paso siguiente.",
     siero:"Es el paso más concentrado de la rutina.", crema:"Sella todo y retiene la hidratación.",
     occhi:"La zona más fina, con fórmula específica.", spf:"El paso que protege los resultados de todos los demás.",
     booster:"Tratamiento intensivo, dos veces por semana."}
};
const ISSUE = {
 it:{idratazione:"Qui lavora sulla disidratazione.", sebo:"Qui agisce su lucidità e pori.",
     rossore:"Qui calma gli arrossamenti.", luminosita:"Qui uniforma il colorito.",
     rughe:"Qui compatta la grana e le linee sottili."},
 en:{idratazione:"Here it works on dehydration.", sebo:"Here it acts on shine and pores.",
     rossore:"Here it calms redness.", luminosita:"Here it evens out the complexion.",
     rughe:"Here it firms texture and fine lines."},
 zh:{idratazione:"这一步针对的是缺水。", sebo:"这一步处理油光和毛孔。",
     rossore:"这一步压泛红。", luminosita:"这一步匀肤色。",
     rughe:"这一步改善肌理和细纹。"},
 de:{idratazione:"Hier arbeitet es gegen Feuchtigkeitsmangel.", sebo:"Hier wirkt es auf Glanz und Poren.",
     rossore:"Hier beruhigt es Rötungen.", luminosita:"Hier gleicht es den Teint aus.",
     rughe:"Hier festigt es Textur und feine Linien."},
 fr:{idratazione:"Ici, il agit sur la déshydratation.", sebo:"Ici, il agit sur la brillance et les pores.",
     rossore:"Ici, il apaise les rougeurs.", luminosita:"Ici, il unifie le teint.",
     rughe:"Ici, il raffermit la texture et les ridules."},
 es:{idratazione:"Aquí actúa sobre la deshidratación.", sebo:"Aquí actúa sobre los brillos y los poros.",
     rossore:"Aquí calma las rojeces.", luminosita:"Aquí unifica el tono.",
     rughe:"Aquí afina la textura y las líneas finas."}
};
function whyText(p, need, taken){
  // filtro sugli assi realmente esistenti: una chiave sconosciuta nel
  // catalogo (è già successo con "texture" al posto di "rughe") pesava 0
  // nel ranking senza dirlo e finiva stampata come "undefined" in scheda.
  const ranked = Object.keys(p.c)
    .filter(k => AXES.includes(k))
    .sort((a,b) => (p.c[b]*(need[b]||0)) - (p.c[a]*(need[a]||0)));
  if(!ranked.length) return pick(ROLE)[p.s];
  const key = ranked.find(k => !taken.has(k)) || ranked[0];
  taken.add(key);
  return pick(ROLE)[p.s] + " " + pick(ISSUE)[key];
}

/* ================================================================
   STEP 4 — schermata di analisi
   ================================================================ */
/* Origine delle metriche: Worker (Claude vision) se configurato, altrimenti
   l'euristica locale. Il Worker restituisce esattamente i campi che
   computeScores() consuma, quindi da qui in giù non cambia nulla.

   Qualunque cosa vada storta — Worker spento, rete assente, timeout, payload
   inatteso — si ricade su measure(). Il cliente non deve MAI restare a mani
   vuote perché un backend non risponde: senza fallback un Worker giù
   significa widget rotto invece che widget meno preciso. */
async function getMetrics(){
  if(!S.shot) return null;
  const url = String(CFG.workerUrl || "").trim();

  /* Pre-filtro locale: gratuito e istantaneo.
     Una foto nera, bruciata o completamente mossa verrebbe scartata anche
     da Claude — ma solo DOPO aver pagato i token, perché il verdetto
     "non utilizzabile" nasce DENTRO il modello, non prima di esso. Una foto
     inutilizzabile costa esattamente quanto una buona. Fermarla qui costa
     zero, e il cliente scopre subito di dover rifare lo scatto invece di
     aspettare ~3s per sentirsi dire la stessa cosa.

     Gira nel browser, quindi è aggirabile: difende dalla foto storta del
     cliente onesto (il caso di gran lunga più frequente), non dall'abuso
     deliberato — per quello c'è il rate limit lato Worker. */
  const local = measure(S.shot);
  if(!url || !local.usable) return local;

  try{
    const ctrl = new AbortController();
    const kill = setTimeout(() => ctrl.abort(), 20000);
    const r = await fetch(url, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ image: S.shot.toDataURL("image/jpeg", 0.82) }),
      signal: ctrl.signal
    });
    clearTimeout(kill);
    if(!r.ok) throw new Error("http " + r.status);
    const j = await r.json();
    // Un payload senza i numeri attesi è indistinguibile da un errore:
    // meglio ricadere sul locale che costruire punteggi su NaN.
    if(typeof j.nTex !== "number" || typeof j.nRed !== "number") throw new Error("payload");
    return { usable: j.usable === true, nRed:j.nRed, nShine:j.nShine,
             nTex:j.nTex, nUneven:j.nUneven, source:"ai" };
  } catch(e){
    return local;   // già calcolato sopra: nessun motivo di rifare measure()
  }
}

function runAnalysis(){
  show("s-run");
  const thumb = $("#thumb");
  if(S.shot){ thumb.src = S.shot.toDataURL("image/jpeg", 0.8); thumb.hidden = false; }
  else       { thumb.hidden = true; }

  const L = pick({
   it:["Rilevazione dell'area del viso","Esposizione e bilanciamento del colore",
       "Uniformità del colorito e rossori","Grana della pelle e lucidità",
       "Costruzione della routine"],
   en:["Detecting the face area","Exposure and colour balance",
       "Tone evenness and redness","Skin texture and shine",
       "Building the routine"],
   zh:["定位人脸区域","曝光与色彩平衡","肤色均匀度与泛红","肌理与油光","生成护肤流程"],
   de:["Gesichtsbereich erkennen","Belichtung und Farbabgleich",
       "Ebenmäßigkeit und Rötungen","Hautbild und Glanz","Routine erstellen"],
   fr:["Détection du visage","Exposition et balance des couleurs",
       "Uniformité du teint et rougeurs","Grain de peau et brillance","Création de la routine"]
  });

  const box = $("#tasks"); box.innerHTML = "";
  const cells = [];
  L.forEach((txt,i)=>{
    const el = document.createElement("div");
    el.className = "taskline";
    el.innerHTML = `<span class="mark"></span><span>${txt}</span><span class="val">—</span>`;
    box.appendChild(el);
    cells.push(el.querySelector(".val"));
    setTimeout(()=> el.classList.add("on"), 320 + i*430);
  });

  /* L'analisi parte SUBITO e corre in parallelo alla barra: la latenza della
     chiamata AI si nasconde dietro i ~3s di animazione invece di sommarsi a
     essi. Si prosegue quando entrambe hanno finito. */
  const metricsP = getMetrics();
  const animP = new Promise(res => setTimeout(res, 320 + L.length*430 + 500));

  Promise.all([metricsP, animP]).then(([m]) => {
    S.metrics = m;
    S.imgOk   = !!(m && m.usable);
    S.scores  = computeScores(S.imgOk ? m : null);
    S.plan    = buildPlan(S.scores);

    /* Registra il test PRIMA di renderizzare, ma tieni da parte il
       precedente: se leggessimo lo storico dentro renderDelta finirebbe
       per confrontare il test con se stesso (e renderResult viene
       richiamata a ogni cambio di lingua o di tier). */
    const overall = Math.round(AXES.reduce((a,k)=>a+S.scores[k],0) / AXES.length);
    const db = STORE.read() || { account:null, history:[] };
    S.prevTest = (db.account && db.history.length)
               ? db.history[db.history.length - 1] : null;
    db.history.push({ ts: Date.now(), overall, scores: {...S.scores} });
    if(db.history.length > 12) db.history.shift();
    STORE.write(db);

    /* `source` è il campo più importante di tutta la telemetria: dice se
       l'analisi è arrivata da Claude ("ai") o dal ripiego locale ("local").
       Il fallback è silenzioso per costruzione — il cliente riceve comunque
       un consiglio — quindi senza questo numero un Worker morto o una
       chiave scaduta potrebbero passare inosservati per mesi. */
    TRACK.send("analysis", {
      photo:  !!S.shot,
      usable: S.imgOk,
      source: m ? (m.source || "local") : "none",
      overall,
      scores: S.scores
    });
    TRACK.send("result", {
      steps: S.plan.plan.map(p => p.h),
      focus: S.plan.focus
    });

    /* Valori di servizio: si usano gli assi normalizzati, gli unici presenti
       sia in modalità AI sia locale (meanL/redRaw esistono solo nel locale). */
    const V = S.imgOk
      ? [ m.source === "ai" ? "AI" : "ok", "ok",
          "Δr " + m.nRed.toFixed(2), "σ " + m.nTex.toFixed(2),
          S.plan.plan.length + " step" ]
      : ["—","—","—","—", S.plan.plan.length + " step"];
    cells.forEach((c,i) => { c.textContent = V[i]; });

    /* Email PRIMA dei risultati (il quiz precedente così portava a casa il
       75,5% dei contatti). Chi ha già lasciato l'email in passato salta il
       cancello: richiederla due volte brucia fiducia senza guadagnare nulla. */
    const gia = STORE.read();
    if(gia && gia.account && gia.account.email){
      goResults();
    } else {
      const np = $("#precap-name"); if(np) np.placeholder = t("pcapName");
      TRACK.send("precap_view");
      show("s-precap");
    }
  });
}

/* Uscita unica dal pre-capture (submit o salta): il risultato si renderizza
   solo qui, mai prima — così il lavoro non viene fatto due volte. */
function goResults(){
  renderResult(); show("s-res");
  /* se l'email è già stata lasciata, il box in fondo alla pagina risultato
     è ridondante: via. PRIMA di fillDev: in produzione il pannello demo
     non esiste e fillDev senza guardia interrompeva la funzione qui sotto
     (bug reale: box email mai nascosto dopo il pre-capture). */
  const acc = STORE.read();
  const cap = $("#s-res .capture");
  if(cap) cap.hidden = !!(S.emailLeft || (acc && acc.account && acc.account.email));
  /* Ponte verso l'assistente AI del catalogo (tablet in negozio): senza
     questo l'assistente non sa nulla del test appena fatto e non può
     rispondere a "perché mi hai consigliato questo?".
     sessionStorage e non localStorage: sparisce quando il tablet resetta
     la scheda, così il cliente dopo non eredita i dati di quello prima.
     Resta nel browser — al nostro server non arriva mai. */
  try {
    sessionStorage.setItem("eli-skt-result", JSON.stringify({
      scores:  S.scores,
      eta:     S.ans && S.ans.age ? S.ans.age : null,
      handles: ((S.plan && S.plan.plan) || []).map(p => p.h)
    }));
  } catch(e){}
  /* L'assistente compare SOLO qui, non durante il test: prima non c'è
     ancora niente di cui parlare. Ora sì — e avendo appena letto i
     punteggi qui sopra, sa rispondere a "perché proprio questi?".
     `aggiorna` rilegge sessionStorage e sostituisce i suggerimenti
     generici con quelli sul risultato. */
  if(window.eliChat){
    window.eliChat.setLang(LANG);
    window.eliChat.aggiorna();
    window.eliChat.mostra(true);
  }
  fillDev();
}

/* ================================================================
   STEP 5 — risultato
   ================================================================ */
function skinLabel(s){
  const dry = s.idratazione < 62, oily = s.sebo < 62, sens = s.rossore < 60;
  const K = pick({
   it:{ mista:"Pelle mista disidratata", grassa:"Pelle grassa disidratata", secca:"Pelle secca",
        sens:"Pelle sensibile reattiva", norm:"Pelle normale in equilibrio", eq:"Pelle mista in equilibrio" },
   en:{ mista:"Combination · dehydrated", grassa:"Oily · dehydrated", secca:"Dry skin",
        sens:"Sensitive · reactive", norm:"Normal · balanced", eq:"Combination · balanced" },
   zh:{ mista:"混合性 · 缺水", grassa:"油性 · 缺水", secca:"干性",
        sens:"敏感 · 易反应", norm:"中性 · 状态平衡", eq:"混合性 · 状态平衡" },
   de:{ mista:"Mischhaut · dehydriert", grassa:"Ölig · dehydriert", secca:"Trockene Haut",
        sens:"Empfindlich · reaktiv", norm:"Normal · im Gleichgewicht", eq:"Mischhaut · im Gleichgewicht" },
   fr:{ mista:"Mixte · déshydratée", grassa:"Grasse · déshydratée", secca:"Peau sèche",
        sens:"Sensible · réactive", norm:"Normale · équilibrée", eq:"Mixte · équilibrée" },
   es:{ mista:"Mixta · deshidratada", grassa:"Grasa · deshidratada", secca:"Piel seca",
        sens:"Sensible · reactiva", norm:"Normal · equilibrada", eq:"Mixta · equilibrada" }
  });
  if(sens) return K.sens;
  if(dry && oily) return K.grassa;
  if(dry) return K.secca;
  if(oily) return K.mista;
  return (s.idratazione > 76 && s.sebo > 76) ? K.norm : K.eq;
}

function renderResult(){
  if(!S.scores) return;
  const s = S.scores, {plan, focus} = S.plan;

  const overall = Math.round(AXES.reduce((a,k)=>a+s[k],0) / AXES.length);
  $("#ring-num").textContent = overall;
  const C = 2 * Math.PI * 44;
  const fg = $("#ring-fg");
  fg.style.stroke = overall < 55 ? "var(--accent)" : overall < 72 ? "var(--primary)" : "var(--ok)";
  fg.setAttribute("stroke-dasharray", C.toFixed(1));
  fg.style.strokeDashoffset = C;
  setTimeout(()=>{ fg.style.strokeDashoffset = (C * (1 - overall/100)).toFixed(1); }, 80);

  $("#r-type").textContent = skinLabel(s);
  $("#r-title").textContent = t("resTitle");

  const f = focus.map(k => pick(AXIS)[k].l.toLowerCase());
  const allGood = AXES.every(k => s[k] >= 78);
  $("#r-sum").textContent = allGood
    ? t("sumAllGood")
    : t("sumFocus").replace("{a}", f[0]).replace("{b}", f[1]);

  // se la foto non era leggibile lo diciamo, invece di spacciare per
  // "misurato" un risultato che viene solo dal questionario
  const note = $("#r-note");
  if(S.shot && !S.imgOk){ note.hidden = false; note.textContent = t("noteUnreadable"); }
  else { note.hidden = true; }

  // punteggi
  const box = $("#r-scores"); box.innerHTML = "";
  AXES.forEach(k=>{
    const v = s[k], A = pick(AXIS)[k];
    const col = v < 55 ? "var(--accent)" : v < 72 ? "var(--primary)" : "var(--ok)";
    const el = document.createElement("div");
    el.className = "score";
    el.innerHTML =
      `<div class="row"><span class="lbl">${A.l}${
        focus.includes(k) ? `<span class="focus-tag">${t("focusTag")}</span>` : ""
      }</span><span class="num">${v}</span></div>
       <div class="bar"><i style="background:${col}"></i></div>
       <small>${v < 68 ? A.lo : A.hi}</small>`;
    box.appendChild(el);
    // setTimeout e non requestAnimationFrame: rAF non scatta se la scheda è
    // in background o la section non sta ancora componendo frame, e le barre
    // resterebbero a zero per sempre.
    setTimeout(()=>{ el.querySelector(".bar i").style.width = v + "%"; }, 60);
  });

  // routine
  $("#r-routine-title").textContent = t("routineTitle");
  $("#r-routine-sub").textContent = t("routineSub");

  /* Selezione per-prodotto. S.sel = Set di handle scelti. Si reinizializza
     (ai soli prodotti core) SOLO quando cambia il piano — non a ogni render,
     altrimenti cambiare lingua azzererebbe le spunte dell'utente. */
  /* I preset selezionano solo il CONSIGLIO di ogni passaggio (mai le
     alternative): con perStep=2 "essenziale" resta 4 prodotti, non 8.
     Con perStep=1 i primari coincidono con l'intero piano → il
     comportamento online è identico a prima. */
  const PRESET = {
    core: plan.filter(p => p.core && !p.alt),
    all:  plan.filter(p => FULL7.includes(p.s) && !p.alt),
    ten:  plan.filter(p => !p.alt)
  };
  if(S.selPlanRef !== plan){
    S.sel = new Set(PRESET.core.map(p => p.h));
    S.selPlanRef = plan;
  }

  // azioni rapide
  $("#picks").querySelector('[data-pick="core"]').textContent =
    `${t("pickCore")} (${PRESET.core.length})`;
  $("#picks").querySelector('[data-pick="all"]').textContent =
    `${t("pickAll")} (${PRESET.all.length})`;
  const tenBtn = $("#picks").querySelector('[data-pick="ten"]');
  /* il terzo preset esiste solo se il pool copre passaggi oltre i 7
     storici (rituale negozio); altrimenti il bottone resta nascosto */
  tenBtn.hidden = !plan.some(p => !FULL7.includes(p.s));
  tenBtn.textContent = `${t("pickTen")} (${PRESET.ten.length})`;
  $("#picks").querySelectorAll("button").forEach(b => b.onclick = () => {
    S.sel = new Set((PRESET[b.dataset.pick] || PRESET.all).map(p=>p.h));
    plan.forEach(p => { const el = list.querySelector(`[data-h="${p.h}"]`);
      if(el) el.setAttribute("aria-pressed", String(S.sel.has(p.h))); });
    updateCart();
  });

  // motivazioni nella lingua attiva
  const taken = new Set();
  plan.forEach(p => { p.why = whyText(p, S.plan.need, taken); });

  // lista costruita UNA volta; il toggle non ricostruisce (evita reload immagini)
  /* Le righe dello stesso passaggio (consiglio + alternativa, perStep=2)
     vanno AFFIANCATE: si raggruppa per step consecutivo e ogni gruppo
     diventa una riga a griglia. Con perStep=1 ogni gruppo ha una sola
     scheda e la resa è identica a prima. */
  const list = $("#r-products"); list.innerHTML = "";
  const groups = [];
  plan.forEach(p => {
    const g = groups[groups.length - 1];
    if(g && g.step === p.s) g.rows.push(p);
    else groups.push({ step: p.s, rows: [p] });
  });
  groups.forEach(g => {
    const rowEl = document.createElement("div");
    rowEl.className = "step-row" + (g.rows.length > 1 ? " two" : "");
    /* Negozio: la riga ha TRE colonne — etichetta del passaggio a sinistra
       (Step N + nome + momento d'uso, come la guida), poi le due proposte.
       Il nome del passaggio esce dalle schede (CSS .skt-kiosk) per non
       ripeterlo tre volte per riga. */
    if(CFG.kiosk){
      rowEl.classList.add("labeled");
      const n = (S.plan.order || []).indexOf(g.step) + 1;
      const lab = document.createElement("div");
      lab.className = "step-label";
      lab.innerHTML = `<i>${n > 0 ? "Step " + n : ""}</i>
        <b>${stepName(g.step)}</b>
        <span class="when">${whenOf(g.step)}</span>`;
      rowEl.appendChild(lab);
    }
    g.rows.forEach(p=>{
    const card = document.createElement("div");
    card.className = "pcard"; card.dataset.h = p.h;
    card.setAttribute("role", "button");
    card.setAttribute("aria-pressed", String(S.sel.has(p.h)));
    card.innerHTML =
      `<span class="pick" aria-hidden="true"></span>
       <span class="media"><img src="${p.img}" alt="" loading="lazy"></span>
       <span class="info">
         <span class="step"><span class="sname">${stepName(p.s)}</span><span class="when">${whenOf(p.s)}</span>${
           p.alt ? `<span class="alt-chip">${t("altBadge")}</span>` : ""
         }</span>
         <span class="brand">${p.b}${
           tierOf(p) === 2 ? `<span class="excl">${t("exclusive")}</span>` : ""
         }</span>
         <span class="name">${p.n}</span>
         <span class="why">${p.why}</span>
       </span>
       <span class="price">${eur(p.p)}</span>
       <a class="view" href="${SHOP + p.h}" target="_blank" rel="noopener">${t("view")}</a>`;
    // click sulla card = seleziona/deseleziona; il link "Vedi" non deve togglare
    card.onclick = e => {
      if(e.target.closest(".view")) return;
      if(S.sel.has(p.h)) S.sel.delete(p.h); else S.sel.add(p.h);
      card.setAttribute("aria-pressed", String(S.sel.has(p.h)));
      updateCart();
    };
    rowEl.appendChild(card);
    });
    list.appendChild(rowEl);
  });

  // rassicurazioni logistiche
  $("#assur").innerHTML = [
    t("assurShip"),
    t("assurFree").replace("{x}", eur(FREE_SHIP)),
    t("assurRet"),
    t("assurHelp")
  ].map(x => `<li><span>${x}</span></li>`).join("");

  updateCart();
  renderDelta(overall);
}

/* Ricalcola totale, sconto e avviso soglia dai soli prodotti selezionati.
   Chiamata a ogni toggle: NON tocca la lista, così le immagini non si
   ricaricano e lo scroll non salta. */
function updateCart(){
  const plan = S.plan.plan;
  const sel = plan.filter(p => S.sel.has(p.h));
  const n = sel.length;
  const listino = sel.reduce((a,b)=>a+b.p, 0);
  const off = discountFor(n);
  const tot = listino * (1 - off);

  $("#r-total").textContent = eur(tot);
  $("#r-cnt").textContent = t("cntSel").replace("{n}", n);

  const was = $("#r-was");
  if(off > 0){
    was.hidden = false;
    was.innerHTML = eur(listino) +
      `<span class="save">${t("saveBadge").replace("{x}", eur(listino - tot))}</span>`;
  } else was.hidden = true;

  const hint = $("#cart-hint");
  if(n === 0){ hint.hidden = true; }
  else if(off === 0){
    hint.hidden = false; hint.className = "cart-hint";
    hint.textContent = t("hintNeed");
  } else {
    hint.hidden = false; hint.className = "cart-hint ok";
    hint.textContent = t("hintOk").replace("{p}", Math.round(off*100));
  }

  $("#btn-cart").disabled = (n === 0);

  /* Kiosk: il riquadro carrello è nascosto via CSS; al suo posto il
     conteggio selezione + l'istruzione per lo staff. */
  if(CFG.kiosk){
    const kn = $("#kiosk-note");
    if(kn){
      kn.hidden = false;
      $("#kiosk-cnt").textContent = t("kioskCnt").replace("{n}", n);
      $("#kiosk-msg").textContent = t("kioskMsg");
    }
  }
}

/* Confronto con il test precedente — esiste solo per chi ha un account,
   ed è la ragione per cui vale la pena averne uno. */
function renderDelta(overall){
  const el = $("#r-delta");
  const prev = S.prevTest;
  if(!prev){ el.hidden = true; return; }
  const d = overall - prev.overall;
  const when = fmtDate(prev.ts);
  el.hidden = false;
  el.className = "delta " + (d > 1 ? "up" : d < -1 ? "down" : "flat");
  /* {x} è sempre il valore ASSOLUTO: il segno sta nel template, altrimenti
     in cinese "下降" (in calo) + "-22" produce una doppia negazione. */
  el.textContent = Math.abs(d) <= 1
    ? t("deltaFlat").replace("{d}", when)
    : (d > 0 ? t("deltaUp") : t("deltaDown"))
        .replace("{x}", Math.abs(d)).replace("{d}", when);
}

/* Aggiunta al carrello via "cart permalink" di Shopify:
   /cart/<variantId>:1,<variantId2>:1?discount=CODICE
   Un solo indirizzo che: aggiunge i prodotti selezionati + applica il codice
   sconto + porta al carrello (lo sconto compare nel carrello e al checkout).
   Il codice si chiama ROUTINE<percentuale> (es. ROUTINE12): il nome codifica
   la percentuale, così resta sempre allineato allo sconto mostrato. Se il
   codice non esiste ancora nel negozio, Shopify lo ignora e aggiunge comunque
   i prodotti (nessun errore). */
$("#btn-cart").onclick = () => {
  const sel = S.plan.plan.filter(p => S.sel.has(p.h) && p.v);
  if(!sel.length) return;
  const off = Math.round(discountFor(sel.length) * 100);
  const items = sel.map(p => p.v + ":1").join(",");
  const code = off > 0 ? "ROUTINE" + off : null;
  const url = "/cart/" + items + (code ? "?discount=" + code : "");
  /* Inviato PRIMA di navigare. `keepalive` nel TRACK.send esiste proprio
     per questo caso: senza, il cambio di pagina abortirebbe la richiesta e
     si perderebbe l'evento di conversione, cioè il più importante. */
  TRACK.send("cart", {
    n: sel.length,
    off,
    listino: +sel.reduce((a,b)=>a+b.p, 0).toFixed(2),
    handles: sel.map(p => p.h)
  });
  if(window.Shopify){                 // storefront reale: naviga davvero
    window.location.href = url;
  } else {                            // demo standalone: mostra l'URL
    alert((LANG === "zh" ? "【Demo】生产版会跳到这个地址(加购+套折扣+进购物车):\n\n"
                         : "[Demo] In produzione naviga qui (aggiunge + sconto + carrello):\n\n")
      + location.origin + url);
  }
};
/* Iscrizione via Worker (Admin API), NON via form storefront.
   Il /contact è inutilizzabile: il JS del tema fa preventDefault su ogni
   form cliente e l'anti-spam di Shopify rifiuta le POST non-navigazione.
   Il Worker crea il cliente server-to-server con un token Admin, bypassando
   entrambi. `keepalive` perché #gateform chiama resetTest() subito dopo,
   che può smontare il contesto prima che la richiesta parta.

   Rete di sicurezza: l'email è già loggata in D1 (evento "email") prima di
   qui, quindi anche se il Worker non avesse il token non si perde nulla. */
function sktSubscribe(email, name){
  const base = String(CFG.workerUrl || "").trim();
  if(!base) return false;                        // demo / worker non configurato
  /* Il piano viaggia insieme all'email: è ciò che permette al Worker di
     spedire SUBITO la routine appena calcolata — niente "rifai il test"
     (esperienza peggiore + una seconda chiamata AI pagata due volte).
     Il carrello proposto = i passaggi core (default del widget). */
  let plan = null;
  try{
    if(S.plan && S.plan.plan.length){
      /* nell'email viaggia solo il consiglio primario di ogni passaggio:
         con perStep=2 (negozio) le alternative raddoppierebbero la lista */
      const rows = S.plan.plan.filter(p => !p.alt);
      const core = rows.filter(p => p.core && p.v);
      const sel  = core.length >= DISC_MIN ? core : rows.filter(p => p.v);
      plan = {
        items: rows.map(p => ({ s:p.s, b:p.b, n:p.n, p:p.p, img:p.img, h:p.h, core:!!p.core })),
        cart:  sel.map(p => p.v + ":1").join(","),
        off:   Math.round(discountFor(sel.length) * 100),
        /* punteggi nel payload → l'email mostra indice complessivo e
           profilo per asse, non solo i prodotti */
        scores: S.scores ? {...S.scores} : null,
        overall: S.scores
          ? Math.round(AXES.reduce((a,k)=>a+S.scores[k],0) / AXES.length)
          : null
      };
    }
  } catch {}
  try{
    fetch(base.replace(/\/+$/, "") + "/subscribe", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        email, name: name || "",
        /* clienti del negozio fisico distinti da quelli del sito: tag e
           canale diversi → segmento a parte + email senza prezzi/carrello */
        tags: CFG.kiosk ? "skin test negozio" : "skin test online",
        channel: CFG.kiosk ? "store" : "web",
        lang: LANG, plan
      }),
      keepalive: true
    }).catch(()=>{});
  } catch {}
  return true;
}
$("#mailform").onsubmit = e => {
  e.preventDefault();
  const email = $("#mail").value.trim();
  if(!email) return;
  const note = $("#mailform").parentNode.querySelector("small");
  TRACK.send("email", { step: "result", email });   // rete di sicurezza in D1
  sktSubscribe(email);
  if(note){ note.textContent = t("capDone"); note.style.opacity = "1"; }
  $("#mail").value = "";
};
/* Il primo test è anonimo. Dal secondo in poi proponiamo l'account —
   ma NON lo imponiamo: "rifai senza salvare" resta disponibile. Un muro
   duro qui farebbe perdere partecipanti che non ne abbiamo abbastanza
   da poter buttare; l'account si vende con il confronto, non col blocco. */
function resetTest(){
  S.qi = 0; S.ans = {goal:[]}; S.shot = null; S.metrics = null;
  S.sel = null; S.selPlanRef = null;   // nuovo test → selezione ricostruita
  S.emailLeft = false;                 // il prossimo cliente del kiosk riparte pulito
  $("#stage").hidden = false;
  $("#s-cam").querySelector(".cam-actions").hidden = false;
  $("#cam-err").hidden = true;
  $("#consent").checked = false;
  $("#consent-err").hidden = true;
  $("#consent-box").classList.remove("nag");
  show("s-intro");
}

$("#btn-again").onclick = () => {
  const db = STORE.read();
  if(db && db.history && db.history.length && !db.account) showGate(db);
  else resetTest();
};

function showGate(db){
  const last = db.history[db.history.length - 1];
  const rows = AXES.map(k =>
    `<div class="row"><span>${pick(AXIS)[k].l}</span><b>${last.scores[k]}</b></div>`).join("");
  $("#gate-prev").innerHTML =
    `<h4>${t("gatePrev")} — ${fmtDate(last.ts)}</h4>
     <div class="row"><span>${t("ringLabel")}</span><b>${last.overall}</b></div>${rows}`;
  show("s-gate");
}

/* Stessa iscrizione nativa del form principale. Lo storico resta per ora in
   localStorage: portarlo su un metafield del cliente richiede un token Admin
   lato server ed è un passo a sé. Finché non c'è, l'email almeno non si
   perde — e chi cambia browser perde solo lo storico, non il contatto. */
$("#gateform").onsubmit = e => {
  e.preventDefault();
  const email = $("#gate-mail").value.trim();
  if(!email) return;
  const db = STORE.read() || { account:null, history:[] };
  db.account = { email };
  STORE.write(db);
  TRACK.send("email", { step: "gate", email });   // rete di sicurezza in D1
  sktSubscribe(email);
  resetTest();
};

/* Pre-capture: il momento in cui il piano è appena stato calcolato.
   sktSubscribe qui porta con sé il piano → il Worker può creare il cliente
   E spedire subito l'email personalizzata con i prodotti veri. */
$("#precapform").onsubmit = e => {
  e.preventDefault();
  const email = $("#precap-mail").value.trim();
  if(!email) return;
  const name = ($("#precap-name").value || "").trim().slice(0, 60);
  const db = STORE.read() || { account:null, history:[] };
  db.account = { email, name };
  STORE.write(db);
  S.emailLeft = true;   // in kiosk STORE è un no-op: il flag vive in sessione
  TRACK.send("email", { step: "precap", email, name });
  sktSubscribe(email, name);
  goResults();
};
$("#precap-skip").onclick = () => { TRACK.send("precap_skip"); goResults(); };
$("#gate-skip").onclick = () => resetTest();

/* ================================================================
   pannello tecnico
   ================================================================ */
function fillDev(){
  const panel = $("#dev-metrics");
  if(!panel) return;   // produzione: il pannello demo non è nel markup
  const tb = panel.querySelector("tbody");
  tb.innerHTML = "";
  const m = S.metrics;
  const rows = m ? [
    ["luminanza media (0–255)", m.meanL.toFixed(1)],
    ["dominante rossa assoluta R−(G+B)/2 · dipende dal fototipo, non usata", m.redRaw.toFixed(1)],
    ["eritema relativo (p90/mediana di R/G) · usata", m.erySpread.toFixed(4)],
    ["pixel speculari oltre 2.2σ (lucidità)", (m.shine*100).toFixed(2) + "%"],
    ["gradiente medio (grana)", m.texture.toFixed(4)],
    ["disomogeneità a blocchi 10×10", m.uneven.toFixed(4)],
    ["—", "—"],
  ] : [["nessuna immagine — solo questionario", "—"]];
  AXES.forEach(k => rows.push([pick(AXIS)[k].l, S.scores[k]]));
  rows.forEach(([a,b])=>{
    const tr = document.createElement("tr");
    tr.innerHTML = `<td>${a}</td><td>${b}</td>`;
    tb.appendChild(tr);
  });
}

/* --- scorciatoie di navigazione: SOLO per la revisione della demo --- */
$$(".jump button").forEach(b=>{
  b.onclick = () => {
    const go = b.dataset.go;
    if(go === "reset"){ STORE.clear(); S.prevTest = null; resetTest();
      alert("Storico locale cancellato: il prossimo test riparte da zero."); return; }
    if(go === "s-intro"){ resetTest(); return; }   // la scorciatoia salta il gate
    if(go === "s-gate"){ const db = STORE.read();
      if(db && db.history && db.history.length) showGate(db);
      else alert("Nessun test precedente in memoria — completane uno prima.");
      return; }
    if(!S.ans.age) S.ans = {age:"25", type:"mista", goal:["idratazione"]};
    if(go === "s-quiz"){ S.qi = 0; show("s-quiz"); renderQuestion(); return; }
    if(go === "s-cam"){ S.camOnly = false; openCamera(); return; }
    if(go === "s-res"){
      S.metrics = S.shot ? measure(S.shot) : null;
      S.scores  = computeScores(S.metrics);
      S.plan    = buildPlan(S.scores);
      renderResult(); fillDev(); show("s-res");
    }
  };
});

applyLang();
TRACK.init();
TRACK.send("view", { returning: !!S.prevTest });
window.addEventListener("pagehide", stopCamera);

/* ================================================================
   Modalità negozio (kiosk)
   - classe sul <main> → il CSS nasconde prezzi, carrello e link "Vedi"
   - reset automatico dopo inattività: il cliente che si allontana a metà
     test non deve lasciare i propri dati sullo schermo al successivo
   ================================================================ */
if(CFG.kiosk){
  const m = $("main");
  if(m) m.classList.add("skt-kiosk");

  /* il pre-capture non deve promettere "sconto già applicato": l'email
     del negozio non contiene né prezzi né sconto. Si scambia la chiave
     i18n e si riapplica la lingua (idempotente). */
  const pl = $('[data-i="pcapLead"]');
  if(pl){ pl.dataset.i = "pcapLeadKiosk"; applyLang(); }

  /* Al catalogo prodotti (pagina kiosk gemella) da due punti: sopra la
     card dell'intro, per chi entra e vuole solo guardare senza fare il
     test, e in fondo al risultato. In entrambi i casi la lingua viaggia
     nell'URL: il catalogo è una pagina separata e senza il parametro
     ripartirebbe in italiano davanti a un cliente che legge in tedesco. */
  const vaiAlCatalogo = () => {
    const u = String(CFG.catalogUrl);
    location.href = u + (u.indexOf("?") > -1 ? "&" : "?") + "lang=" + LANG;
  };
  const cb = $("#btn-catalog");
  if(cb && CFG.catalogUrl){
    cb.hidden = false;
    cb.dataset.i = "catBtn";
    cb.onclick = vaiAlCatalogo;
    applyLang();
  }
  const cbTop = $("#btn-catalog-intro");
  if(cbTop && CFG.catalogUrl){
    cbTop.hidden = false;
    cbTop.dataset.i = "catBtnTop";
    cbTop.onclick = vaiAlCatalogo;
    applyLang();
  }

  const IDLE_MS = Math.max(1, CFG.kioskIdle ?? 3) * 60000;
  const APERTA_DA = Date.now();
  const MAX_APERTURA = 6 * 60 * 60 * 1000;   // 6 ore
  let idleT = null;
  const arm = () => {
    clearTimeout(idleT);
    idleT = setTimeout(() => {
      /* Il tablet sta acceso per giorni sulla stessa pagina: senza questo
         una modifica al tema non arriverebbe mai. Si ricarica solo dopo
         il timeout di inattività — mai con un cliente davanti — e prima
         si cancellano i punteggi, che sopravvivrebbero al reload. */
      /* navigator.onLine non è una garanzia, ma intercetta il caso comune
         (wifi caduto): ricaricare senza rete lascerebbe il tablet su una
         pagina di errore del browser finché qualcuno non se ne accorge. */
      if(Date.now() - APERTA_DA > MAX_APERTURA && navigator.onLine !== false){
        try { sessionStorage.removeItem("eli-skt-result"); } catch(e){}
        location.reload();
        return;
      }
      /* già sull'intro: nulla da azzerare (e niente loop di reset) */
      if(!$("#s-intro").hidden) { arm(); return; }
      TRACK.send("kiosk_reset");
      /* la conversazione sparisce col cliente, e con lei i punteggi:
         il prossimo non deve trovare né la chat né il test di prima */
      try { sessionStorage.removeItem("eli-skt-result"); } catch(e){}
      if(window.eliChat){ window.eliChat.reset(); window.eliChat.mostra(false); }
      resetTest();
      arm();
    }, IDLE_MS);
  };
  ["pointerdown","keydown","touchstart"].forEach(ev =>
    document.addEventListener(ev, arm, {passive:true}));
  arm();
}

})();